import _defineProperty from "/Users/shorlyn/Documents/project/core/campus-all/rccms-web/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _typeof from "/Users/shorlyn/Documents/project/core/campus-all/rccms-web/node_modules/@babel/runtime/helpers/esm/typeof.js";
import _slicedToArray from "/Users/shorlyn/Documents/project/core/campus-all/rccms-web/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _regenerator from "/Users/shorlyn/Documents/project/core/campus-all/rccms-web/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/Users/shorlyn/Documents/project/core/campus-all/rccms-web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _toConsumableArray from "/Users/shorlyn/Documents/project/core/campus-all/rccms-web/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _objectSpread from "/Users/shorlyn/Documents/project/core/campus-all/rccms-web/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.reduce.js";
import "core-js/modules/es.map.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.starts-with.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/es.string.link.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { mapState } from 'vuex';
import { searchUsers, getContactUsers, getContactDepartments, getContactSchools, getContactFaculties, getContactProfessions, getContactClazzes, getContactStudents, getGroupMembers, getGroupNotice, updateGroupInfo, updateGroupNotice, updateGroupAllMute, updateGroupAdmin, updateGroupMemberMute, removeGroupMember, transferGroupOwner, uploadImage } from '@/api/chat';
import dayjs from 'dayjs';
import ApprovalMessageCard from './components/ApprovalMessageCard.vue';
import MessageCard from './components/MessageCard.vue';
import CustomerServicePanel from '@/components/CustomerServiceChat/Panel.vue';
import customerServiceApi from '@/api/customer-service';
import desktopNotify from '@/utils/desktop-notify';

// 时间条显示阈值（5分钟，可配置）
var TIME_GAP_THRESHOLD = 5 * 60 * 1000;
var WEEK_DAYS = ['周日', '周一', '周二', '周三', '周四', '周五', '周六'];

/**
 * 格式化时间条文案
 * - 今天：HH:mm
 * - 昨天：昨天 HH:mm
 * - 7天内：周X HH:mm
 * - 更早：yyyy/MM/dd HH:mm
 */
function formatTimeLabel(time) {
  var d = dayjs(time);
  if (!d.isValid()) return '';
  var now = dayjs();
  var today = now.startOf('day');
  var yesterday = today.subtract(1, 'day');
  var weekAgo = today.subtract(6, 'day');
  if (d.isAfter(today)) {
    return d.format('HH:mm');
  } else if (d.isAfter(yesterday)) {
    return '昨天 ' + d.format('HH:mm');
  } else if (d.isAfter(weekAgo)) {
    return WEEK_DAYS[d.day()] + ' ' + d.format('HH:mm');
  } else {
    return d.format('YYYY/MM/DD HH:mm');
  }
}
export default {
  name: 'ImChat',
  components: {
    ApprovalMessageCard: ApprovalMessageCard,
    MessageCard: MessageCard,
    CustomerServicePanel: CustomerServicePanel
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      drawerVisible: false,
      view: 'list',
      // list | messages | groupDetail | groupMembers | newChat
      openCustomerServiceOnOpen: false,
      inputText: '',
      searchKeyword: '',
      searchResults: [],
      searchLoading: false,
      searchTimer: null,
      orgUsersLoading: false,
      orgDeptsLoading: false,
      orgSchoolsLoading: false,
      studentFacultiesLoading: false,
      studentProfessionsLoading: false,
      studentClazzesLoading: false,
      studentUsersLoading: false,
      orgUsers: [],
      orgDepts: [],
      orgSchools: [],
      studentFaculties: [],
      studentProfessions: [],
      studentClazzes: [],
      studentUsers: [],
      studentProfessionsCache: {},
      studentClazzesCache: {},
      studentUsersCache: {},
      selectedContactType: 'teacher',
      selectedOrgCityKey: null,
      selectedOrgSchoolId: null,
      selectedOrgDeptId: null,
      selectedStudentFacultyId: null,
      selectedStudentProfId: null,
      selectedStudentClazzId: null,
      desktopNotifyPermission: 'default',
      listSearchKeyword: '',
      listFilter: 'all',
      selectedChat: null,
      groupDetailLoading: false,
      groupMembers: [],
      groupMembersChatId: null,
      groupNoticeDetail: null,
      loadingHistory: false,
      scrollBottomTimers: [],
      nearBottom: true,
      newMessageHintCount: 0,
      customerServiceAgent: null,
      // Emoji 列表 (共100个)
      emojiList: [
      // 情绪与表情 (60)
      '😀', '😁', '😂', '🤣', '😃', '😄', '😅', '😆', '😉', '😊', '😋', '😎', '😍', '😘', '😗', '😙', '😚', '☺️', '🙂', '🤗', '🤩', '🤔', '🤨', '😐', '😑', '😶', '🙄', '😏', '😣', '😥', '😮', '🤐', '😯', '😪', '😫', '😴', '😌', '😛', '😜', '😝', '🤤', '😒', '😓', '😔', '😕', '🙃', '🤑', '😲', '☹️', '🙁', '😖', '😞', '😟', '😤', '😢', '😭', '😦', '😧', '😨', '😩',
      // 工作/状态/手势 (25)
      '👍', '👎', '👌', '✌️', '🤞', '🤟', '🤘', '🤙', '👈', '👉', '👆', '👇', '☝️', '✋', '🤚', '🖐', '🖖', '👋', '👏', '🙌', '👐', '🤲', '🤝', '🙏', '💪',
      // 提示/特定含义 (15)
      '💼', '💻', '💡', '📌', '📎', '✏️', '📝', '📅', '📞', '✉️', '✅', '❌', '⚠️', '🔥', '💯']
    };
  },
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapState('chat', ['chats', 'currentChatId', 'messages', 'pendingToast'])), mapState('user', {
    userId: 'userId',
    userName: 'name',
    userAvatar: 'avatar',
    currentSchoolId: 'currentSchoolId',
    userSchools: 'userSchools',
    userInfo: 'info'
  })), {}, {
    uploadHeaders: function uploadHeaders() {
      return {
        Authorization: 'Bearer ' + this.$store.getters.token
      };
    },
    desktopNotifySupported: function desktopNotifySupported() {
      return desktopNotify.isSupported();
    },
    headerTitle: function headerTitle() {
      if (this.view === 'messages' && this.selectedChat) return this.selectedChat.name || '消息';
      if (this.view === 'customerService') return '网页咨询';
      if (this.view === 'groupDetail') return '群聊详情';
      if (this.view === 'groupMembers') return '全部群成员';
      if (this.view === 'newChat') return '新建对话';
      return '消息';
    },
    currentMessages: function currentMessages() {
      return this.messages[this.currentChatId] || [];
    },
    // 专门供监听的长度属性，用来触发新消息滚动
    currentMessagesLength: function currentMessagesLength() {
      return this.currentMessages.length;
    },
    /**
     * 带时间条标记的消息列表
     * 对 currentMessages 计算 _showTime / _timeLabel，prepend 也安全
     */
    displayMessages: function displayMessages() {
      var msgs = this.currentMessages;
      if (!msgs || msgs.length === 0) return [];
      return msgs.map(function (msg, i) {
        var cur = dayjs(msg.createdTime);
        var showTime = false;
        if (i === 0) {
          showTime = true;
        } else {
          var prev = dayjs(msgs[i - 1].createdTime);
          if (cur.isValid() && prev.isValid()) {
            // 跨天 或 超过阈值
            if (!cur.isSame(prev, 'day') || cur.diff(prev) >= TIME_GAP_THRESHOLD) {
              showTime = true;
            }
          }
        }
        return _objectSpread(_objectSpread({}, msg), {}, {
          _showTime: showTime,
          _timeLabel: showTime ? formatTimeLabel(msg.createdTime) : ''
        });
      });
    },
    chatFilters: function chatFilters() {
      return [{
        label: '全部',
        value: 'all'
      }, {
        label: '单聊',
        value: 'direct'
      }, {
        label: '群聊',
        value: 'group'
      }, {
        label: '系统',
        value: 'system'
      }];
    },
    drawerSize: function drawerSize() {
      return this.view === 'customerService' ? '760px' : '420px';
    },
    filteredChats: function filteredChats() {
      var _this = this;
      var keyword = (this.listSearchKeyword || '').trim().toLowerCase();
      return (this.chats || []).filter(function (chat) {
        if (!_this.matchesChatFilter(chat)) return false;
        if (!keyword) return true;
        return _this.matchesChatKeyword(chat, keyword);
      });
    },
    selectedChatIsGroup: function selectedChatIsGroup() {
      return this.isGroupChat(this.selectedChat);
    },
    currentUserGroupMember: function currentUserGroupMember() {
      var _this$selectedChat,
        _this2 = this;
      if (!this.selectedChatIsGroup || !((_this$selectedChat = this.selectedChat) !== null && _this$selectedChat !== void 0 && _this$selectedChat.id)) return null;
      if (this.groupMembersChatId !== this.selectedChat.id) return null;
      return (this.groupMembers || []).find(function (member) {
        return _this2.isCurrentGroupMember(member);
      }) || null;
    },
    currentUserGroupRole: function currentUserGroupRole() {
      var _this$currentUserGrou, _this$currentUserGrou2;
      return Number((_this$currentUserGrou = (_this$currentUserGrou2 = this.currentUserGroupMember) === null || _this$currentUserGrou2 === void 0 ? void 0 : _this$currentUserGrou2.role) !== null && _this$currentUserGrou !== void 0 ? _this$currentUserGrou : -1);
    },
    canInviteGroupMember: function canInviteGroupMember() {
      return this.currentUserGroupRole === 1 || this.currentUserGroupRole === 2;
    },
    canEditGroupInfo: function canEditGroupInfo() {
      return this.currentUserGroupRole === 1;
    },
    currentUserGroupMuted: function currentUserGroupMuted() {
      var _this$currentUserGrou3;
      return !!((_this$currentUserGrou3 = this.currentUserGroupMember) !== null && _this$currentUserGrou3 !== void 0 && _this$currentUserGrou3.isMuted);
    },
    currentUserByAllMuteBlocked: function currentUserByAllMuteBlocked() {
      var _this$selectedChat2;
      if (!this.selectedChatIsGroup) return false;
      if (!((_this$selectedChat2 = this.selectedChat) !== null && _this$selectedChat2 !== void 0 && _this$selectedChat2.isAllMuted)) return false;
      return this.currentUserGroupRole !== 1 && this.currentUserGroupRole !== 2;
    },
    canCurrentUserSendInSelectedChat: function canCurrentUserSendInSelectedChat() {
      if (!this.selectedChatIsGroup) return true;
      if (this.currentUserGroupMuted) return false;
      if (this.currentUserByAllMuteBlocked) return false;
      return true;
    },
    selectedChatInputPlaceholder: function selectedChatInputPlaceholder() {
      if (this.currentUserGroupMuted) {
        return '你已被禁言，暂时无法发言';
      }
      if (this.currentUserByAllMuteBlocked) {
        return '当前群聊已开启全员禁言，仅群主和管理员可发言';
      }
      return '输入消息，Enter 发送';
    },
    groupMemberCount: function groupMemberCount() {
      var _this$selectedChat3;
      return (this.groupMembers || []).length || Number(((_this$selectedChat3 = this.selectedChat) === null || _this$selectedChat3 === void 0 ? void 0 : _this$selectedChat3.memberCount) || 0) || 0;
    },
    groupPreviewMembers: function groupPreviewMembers() {
      var maxCells = this.canInviteGroupMember ? 14 : 15;
      return (this.groupMembers || []).slice(0, maxCells);
    },
    groupOperationItems: function groupOperationItems() {
      var _this$groupNoticeDeta;
      var items = [{
        key: 'notice',
        label: '群公告',
        desc: ((_this$groupNoticeDeta = this.groupNoticeDetail) === null || _this$groupNoticeDeta === void 0 ? void 0 : _this$groupNoticeDeta.notice) || '暂无群公告',
        icon: 'el-icon-bell'
      }];
      if (this.canEditGroupInfo) {
        var _this$selectedChat4;
        items.push({
          key: 'name',
          label: '群名称',
          desc: ((_this$selectedChat4 = this.selectedChat) === null || _this$selectedChat4 === void 0 ? void 0 : _this$selectedChat4.name) || '未命名群聊',
          icon: 'el-icon-edit-outline'
        });
      }
      if (this.canInviteGroupMember) {
        var _this$selectedChat5;
        items.push({
          key: 'mute',
          label: '禁言操作',
          desc: (_this$selectedChat5 = this.selectedChat) !== null && _this$selectedChat5 !== void 0 && _this$selectedChat5.isAllMuted ? '当前已开启全员禁言，仅群主和管理员可发言' : '管理全员禁言与成员禁言',
          icon: 'el-icon-warning-outline'
        });
      }
      return items;
    },
    availableOrgSchools: function availableOrgSchools() {
      var _this$userInfo;
      var schools = Array.isArray(this.orgSchools) ? this.orgSchools.filter(Boolean) : [];
      if (schools.length > 0) return schools;
      var userSchools = Array.isArray(this.userSchools) ? this.userSchools.filter(Boolean) : [];
      if (userSchools.length > 0) return userSchools;
      var primarySchool = ((_this$userInfo = this.userInfo) === null || _this$userInfo === void 0 ? void 0 : _this$userInfo.school) || null;
      return primarySchool ? [primarySchool] : [];
    },
    selfOrgCityKey: function selfOrgCityKey() {
      var _this3 = this;
      var currentSchool = this.availableOrgSchools.find(function (item) {
        return String(item.id) === String(_this3.currentSchoolId);
      });
      return this.getSchoolCityKey(currentSchool || this.availableOrgSchools[0] || null);
    },
    contactTypeOptions: function contactTypeOptions() {
      return [{
        label: '老师',
        value: 'teacher',
        disabled: false
      }, {
        label: '学生',
        value: 'student',
        disabled: false
      }, {
        label: '家长',
        value: 'parent',
        disabled: true
      }, {
        label: '供应商',
        value: 'supplier',
        disabled: true
      }];
    },
    availableOrgCities: function availableOrgCities() {
      var _this4 = this;
      var cityMap = new Map();
      this.availableOrgSchools.forEach(function (school) {
        var key = _this4.getSchoolCityKey(school);
        if (!cityMap.has(key)) {
          cityMap.set(key, {
            key: key,
            label: _this4.getSchoolCityLabel(school)
          });
        }
      });
      return Array.from(cityMap.values()).sort(function (a, b) {
        if (a.key === _this4.selfOrgCityKey) return -1;
        if (b.key === _this4.selfOrgCityKey) return 1;
        return String(a.label || '').localeCompare(String(b.label || ''), 'zh-CN');
      });
    },
    schoolsInSelectedCity: function schoolsInSelectedCity() {
      var _this5 = this;
      var cityKey = this.selectedOrgCityKey || this.selfOrgCityKey;
      return this.availableOrgSchools.filter(function (school) {
        return _this5.getSchoolCityKey(school) === cityKey;
      }).sort(function (a, b) {
        if (String(a.id) === String(_this5.currentSchoolId)) return -1;
        if (String(b.id) === String(_this5.currentSchoolId)) return 1;
        return String(a.name || '').localeCompare(String(b.name || ''), 'zh-CN');
      });
    },
    filteredOrgDepts: function filteredOrgDepts() {
      var schoolId = this.selectedOrgSchoolId;
      var list = Array.isArray(this.orgDepts) ? this.orgDepts : [];
      if (!schoolId) return list;
      var matched = list.filter(function (dept) {
        var _ref, _dept$schoolId, _dept$school, _dept$school2;
        var deptSchoolId = (_ref = (_dept$schoolId = dept === null || dept === void 0 ? void 0 : dept.schoolId) !== null && _dept$schoolId !== void 0 ? _dept$schoolId : dept === null || dept === void 0 || (_dept$school = dept.school) === null || _dept$school === void 0 ? void 0 : _dept$school.id) !== null && _ref !== void 0 ? _ref : dept === null || dept === void 0 || (_dept$school2 = dept.school) === null || _dept$school2 === void 0 ? void 0 : _dept$school2.schoolId;
        return !deptSchoolId || String(deptSchoolId) === String(schoolId);
      });
      return matched.length > 0 ? matched : list;
    },
    filteredOrgUsers: function filteredOrgUsers() {
      var _this6 = this;
      var schoolId = this.selectedOrgSchoolId;
      var deptId = this.selectedOrgDeptId;
      return (this.orgUsers || []).filter(function (user) {
        if (!_this6.matchesContactType(user)) return false;
        if (schoolId && !_this6.matchesUserSchool(user, schoolId)) return false;
        if (deptId && !_this6.matchesUserDept(user, deptId)) return false;
        return true;
      });
    },
    studentBreadcrumbs: function studentBreadcrumbs() {
      var _this7 = this;
      var breadcrumbs = [{
        label: '全部院系',
        level: 'root'
      }];
      var faculty = this.studentFaculties.find(function (item) {
        return String(item.id) === String(_this7.selectedStudentFacultyId);
      });
      var profession = this.studentProfessions.find(function (item) {
        return String(item.id) === String(_this7.selectedStudentProfId);
      });
      var clazz = this.studentClazzes.find(function (item) {
        return String(item.id) === String(_this7.selectedStudentClazzId);
      });
      if (faculty) breadcrumbs.push({
        label: faculty.name,
        level: 'faculty',
        id: faculty.id
      });
      if (profession) breadcrumbs.push({
        label: profession.name,
        level: 'profession',
        id: profession.id
      });
      if (clazz) breadcrumbs.push({
        label: clazz.name,
        level: 'clazz',
        id: clazz.id
      });
      return breadcrumbs;
    },
    studentBrowserTitle: function studentBrowserTitle() {
      if (this.selectedStudentClazzId) return '班级学生';
      if (this.selectedStudentProfId) return '专业学生';
      if (this.selectedStudentFacultyId) return '院系学生';
      return '全部学生';
    },
    currentStudentPanelItems: function currentStudentPanelItems() {
      if (!this.selectedStudentFacultyId) {
        return [{
          id: null,
          name: '全部院系',
          type: 'faculty-all'
        }].concat(_toConsumableArray((this.studentFaculties || []).map(function (item) {
          return _objectSpread(_objectSpread({}, item), {}, {
            type: 'faculty'
          });
        })));
      }
      if (!this.selectedStudentProfId) {
        return [{
          id: null,
          name: '全部专业',
          type: 'profession-all'
        }].concat(_toConsumableArray((this.studentProfessions || []).map(function (item) {
          return _objectSpread(_objectSpread({}, item), {}, {
            type: 'profession'
          });
        })));
      }
      if (!this.selectedStudentClazzId) {
        return [{
          id: null,
          name: '全部班级',
          type: 'clazz-all'
        }].concat(_toConsumableArray((this.studentClazzes || []).map(function (item) {
          return _objectSpread(_objectSpread({}, item), {}, {
            type: 'clazz'
          });
        })));
      }
      return [];
    },
    studentPanelSelectionKey: function studentPanelSelectionKey() {
      if (!this.selectedStudentFacultyId) return 'faculty:all';
      if (!this.selectedStudentProfId) return 'profession:all';
      if (!this.selectedStudentClazzId) return 'clazz:all';
      return "clazz:".concat(this.selectedStudentClazzId);
    },
    studentPanelBusy: function studentPanelBusy() {
      return this.studentProfessionsLoading || this.studentClazzesLoading || this.studentUsersLoading;
    }
  }),
  watch: {
    visible: function visible(val) {
      this.drawerVisible = val;
    },
    drawerVisible: function drawerVisible(val) {
      this.$emit('update:visible', val);
    },
    currentMessagesLength: function currentMessagesLength(newLen, oldLen) {
      if (this.view !== 'messages' || !this.currentChatId || this.loadingHistory) return;
      if (newLen > oldLen) {
        var latest = this.currentMessages[this.currentMessages.length - 1];
        if (this.nearBottom || this.isMyMessage(latest)) {
          this.newMessageHintCount = 0;
          this.scrollToBottom();
        } else {
          this.newMessageHintCount = Math.min(99, this.newMessageHintCount + (newLen - oldLen));
        }
      }
    },
    // 监听待弹 toast
    pendingToast: function pendingToast(toast) {
      var _this8 = this;
      if (!toast) return;
      var content = toast.content.length > 30 ? toast.content.substring(0, 30) + '...' : toast.content;
      var chatId = toast.chatId;
      var h = this.$createElement;
      this.$notify({
        title: toast.senderName,
        message: h('span', {
          style: 'cursor:pointer;color:#303133'
        }, content),
        position: 'top-right',
        duration: 4000,
        type: 'info',
        onClick: function () {
          var _onClick = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
            return _regenerator().w(function (_context) {
              while (1) switch (_context.n) {
                case 0:
                  // 点击 toast → 打开 Drawer 
                  _this8.drawerVisible = true;

                  // 确保聊天列表已加载（如果抽屉是首次打开，此时 chats 可能是空的）
                  if (!(!_this8.chats || _this8.chats.length === 0 || !_this8.chats.find(function (c) {
                    return c.id === chatId;
                  }))) {
                    _context.n = 1;
                    break;
                  }
                  _context.n = 1;
                  return _this8.$store.dispatch('chat/loadChats');
                case 1:
                  _this8.$nextTick(function () {
                    // 配合现在的 loadHistory，清理消息时还需要重置该聊天的分页状态
                    _this8.$store.commit('chat/SET_HISTORY_STATE', {
                      chatId: chatId,
                      page: 0,
                      hasMore: true
                    });
                    // 清空该会话缓存，强制 selectChat 触发 loadHistory 获取第1页
                    _this8.$store.commit('chat/SET_MESSAGES', {
                      chatId: chatId,
                      messages: []
                    });
                    var chat = _this8.chats.find(function (c) {
                      return c.id === chatId;
                    });
                    if (chat) {
                      _this8.openChat(chat);
                    }
                  });
                case 2:
                  return _context.a(2);
              }
            }, _callee);
          }));
          function onClick() {
            return _onClick.apply(this, arguments);
          }
          return onClick;
        }()
      });
      // 消费完毕，置空
      this.$store.commit('chat/SET_PENDING_TOAST', null);
    }
  },
  mounted: function mounted() {
    window.addEventListener('open-customer-service-chat', this.handleOpenCustomerServiceEvent);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('open-customer-service-chat', this.handleOpenCustomerServiceEvent);
    this.clearScrollBottomTimers();
  },
  methods: {
    handleOpen: function handleOpen() {
      var _this9 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _this9.$store.commit('chat/SET_DRAWER_OPEN', true);
              _this9.$store.dispatch('chat/loadChats');
              _this9.refreshDesktopNotifyPermission();
              _context2.n = 1;
              return _this9.loadCustomerServiceAgent();
            case 1:
              if (_this9.openCustomerServiceOnOpen && _this9.customerServiceAgent) {
                _this9.view = 'customerService';
              } else {
                _this9.view = 'list';
              }
              _this9.openCustomerServiceOnOpen = false;
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    handleClose: function handleClose() {
      this.$store.commit('chat/SET_DRAWER_OPEN', false);
      this.drawerVisible = false;
      this.view = 'list';
      this.groupMembers = [];
      this.groupMembersChatId = null;
      this.groupNoticeDetail = null;
      this.groupDetailLoading = false;
    },
    goBack: function goBack() {
      if (this.view === 'groupMembers') {
        this.view = 'groupDetail';
        return;
      }
      this.view = 'list';
      this.searchKeyword = '';
      this.searchResults = [];
    },
    loadCustomerServiceAgent: function loadCustomerServiceAgent() {
      var _this0 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var _yield$customerServic, data, _t;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              _context3.p = 0;
              _context3.n = 1;
              return customerServiceApi.methods.getAllAgents.call(_this0);
            case 1:
              _yield$customerServic = _context3.v;
              data = _yield$customerServic.data;
              _this0.customerServiceAgent = (data || []).find(function (agent) {
                return Number(agent.userId) === Number(_this0.userId) && agent.isActive;
              }) || null;
              _context3.n = 3;
              break;
            case 2:
              _context3.p = 2;
              _t = _context3.v;
              _this0.customerServiceAgent = null;
            case 3:
              return _context3.a(2);
          }
        }, _callee3, null, [[0, 2]]);
      }))();
    },
    openCustomerService: function openCustomerService() {
      var _this1 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              if (_this1.customerServiceAgent) {
                _context4.n = 1;
                break;
              }
              return _context4.a(2);
            case 1:
              _this1.view = 'customerService';
            case 2:
              return _context4.a(2);
          }
        }, _callee4);
      }))();
    },
    handleOpenCustomerServiceEvent: function handleOpenCustomerServiceEvent() {
      var _this10 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              _this10.openCustomerServiceOnOpen = true;
              _this10.drawerVisible = true;
              _context5.n = 1;
              return _this10.loadCustomerServiceAgent();
            case 1:
              if (_this10.customerServiceAgent) {
                _context5.n = 2;
                break;
              }
              _this10.openCustomerServiceOnOpen = false;
              _this10.$message.warning('当前账号未绑定启用的客服人员，无法进入网页咨询');
              return _context5.a(2);
            case 2:
              _this10.view = 'customerService';
            case 3:
              return _context5.a(2);
          }
        }, _callee5);
      }))();
    },
    refreshDesktopNotifyPermission: function refreshDesktopNotifyPermission() {
      this.desktopNotifyPermission = desktopNotify.getPermission();
    },
    enableDesktopNotify: function enableDesktopNotify() {
      var _this11 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
        var permission;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              if (_this11.desktopNotifySupported) {
                _context6.n = 1;
                break;
              }
              _this11.$message.warning('当前浏览器环境不支持桌面通知');
              return _context6.a(2);
            case 1:
              _context6.n = 2;
              return desktopNotify.requestPermission();
            case 2:
              permission = _context6.v;
              _this11.desktopNotifyPermission = permission;
              if (!(permission === 'granted')) {
                _context6.n = 3;
                break;
              }
              _this11.$message.success('桌面通知已开启');
              return _context6.a(2);
            case 3:
              if (!(permission === 'denied')) {
                _context6.n = 4;
                break;
              }
              _this11.$message.warning('桌面通知已被浏览器拦截，请在浏览器设置中手动开启');
              return _context6.a(2);
            case 4:
              _this11.$message.info('你还没有开启桌面通知');
            case 5:
              return _context6.a(2);
          }
        }, _callee6);
      }))();
    },
    openNewChat: function openNewChat() {
      var _this12 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
        var _this12$availableOrgC, _this12$schoolsInSele, _this12$availableOrgS;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.n) {
            case 0:
              _this12.view = 'newChat';
              _context7.n = 1;
              return _this12.loadOrgSchools();
            case 1:
              if (!_this12.selectedOrgCityKey) {
                _this12.selectedOrgCityKey = _this12.selfOrgCityKey || ((_this12$availableOrgC = _this12.availableOrgCities[0]) === null || _this12$availableOrgC === void 0 ? void 0 : _this12$availableOrgC.key) || null;
              }
              if (!_this12.selectedOrgSchoolId) {
                _this12.selectedOrgSchoolId = _this12.currentSchoolId || ((_this12$schoolsInSele = _this12.schoolsInSelectedCity[0]) === null || _this12$schoolsInSele === void 0 ? void 0 : _this12$schoolsInSele.id) || ((_this12$availableOrgS = _this12.availableOrgSchools[0]) === null || _this12$availableOrgS === void 0 ? void 0 : _this12$availableOrgS.id) || null;
              }
              _context7.n = 2;
              return _this12.ensureContactTypeDataLoaded();
            case 2:
              return _context7.a(2);
          }
        }, _callee7);
      }))();
    },
    // 会话列表
    getUnread: function getUnread(chat) {
      return chat.unreadCount || 0;
    },
    stripMentionMarkup: function stripMentionMarkup(text) {
      return String(text || '').replace(/<M\d+>(.*?)<\/M>/g, '$1');
    },
    hasMentionForMe: function hasMentionForMe(text) {
      var content = String(text || '');
      var myId = String(this.userId || '');
      if (!content) return false;
      if (content.includes('<M0>@所有人</M>')) return true;
      return myId && content.includes("<M".concat(myId, ">"));
    },
    formatPlainPreview: function formatPlainPreview(text) {
      var content = this.stripMentionMarkup(text).trim();
      if (!content) return '';
      return content.length > 30 ? content.substring(0, 30) + '...' : content;
    },
    formatConversationTime: function formatConversationTime(time) {
      var d = dayjs(time);
      if (!d.isValid()) return '';
      var now = dayjs();
      if (d.isSame(now, 'day')) return d.format('HH:mm');
      if (d.isSame(now.subtract(1, 'day'), 'day')) return '昨天';
      if (d.isSame(now, 'year')) return d.format('MM-DD');
      return d.format('YYYY-MM-DD');
    },
    escapeHtml: function escapeHtml(text) {
      return String(text || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
    },
    renderTextContent: function renderTextContent(msg) {
      var content = String((msg === null || msg === void 0 ? void 0 : msg.content) || '');
      if (!content) return '';
      var myId = String(this.userId || '');
      var html = this.escapeHtml(content).replace(/&lt;M(\d+)&gt;(.*?)&lt;\/M&gt;/g, function (full, id, inner) {
        var isAll = id === '0';
        var isMe = myId && id === myId;
        var classes = ['msg-mention'];
        if (isAll) classes.push('mention-all');
        if (isMe) classes.push('mention-me');
        return "<span class=\"".concat(classes.join(' '), "\">").concat(inner, "</span>");
      });
      return html.replace(/\n/g, '<br>');
    },
    getChatCategory: function getChatCategory(chat) {
      if (!chat) return 'direct';
      if (chat.userType === 0 || chat.type === 0) return 'system';
      if (chat.type === 2 || chat.userType === 9 || chat.receiveType === 9) return 'group';
      return 'direct';
    },
    isGroupChat: function isGroupChat(chat) {
      return this.getChatCategory(chat) === 'group';
    },
    getAvatarFallback: function getAvatarFallback(chat) {
      var name = String((chat === null || chat === void 0 ? void 0 : chat.name) || '').trim();
      if (!name) return '?';
      return name[0];
    },
    getUserSchoolName: function getUserSchoolName(user) {
      var _user$school;
      return (user === null || user === void 0 || (_user$school = user.school) === null || _user$school === void 0 ? void 0 : _user$school.name) || (user === null || user === void 0 ? void 0 : user.schoolName) || '';
    },
    getUserDeptName: function getUserDeptName(user) {
      if (user !== null && user !== void 0 && user.deptName) return user.deptName;
      if (Array.isArray(user === null || user === void 0 ? void 0 : user.depts) && user.depts.length > 0) {
        return user.depts.map(function (item) {
          return item === null || item === void 0 ? void 0 : item.name;
        }).filter(Boolean).join(' / ');
      }
      return (user === null || user === void 0 ? void 0 : user.departmentName) || '';
    },
    getUserPrimaryRole: function getUserPrimaryRole(user) {
      var _user$post;
      if (user !== null && user !== void 0 && (_user$post = user.post) !== null && _user$post !== void 0 && _user$post.name) return user.post.name;
      if (Array.isArray(user === null || user === void 0 ? void 0 : user.roles) && user.roles.length > 0) {
        return user.roles.map(function (role) {
          return (role === null || role === void 0 ? void 0 : role.displayName) || (role === null || role === void 0 ? void 0 : role.name);
        }).filter(Boolean)[0] || '';
      }
      return '';
    },
    getSchoolCityKey: function getSchoolCityKey(school) {
      if (!school) return 'default';
      return [school.provName, school.cityName].filter(Boolean).join('_') || 'default';
    },
    getSchoolCityLabel: function getSchoolCityLabel(school) {
      if (!school) return '未分组';
      return [school.provName, school.cityName].filter(Boolean).join(' · ') || school.name || '未分组';
    },
    matchesUserSchool: function matchesUserSchool(user, schoolId) {
      var _user$school2, _user$school3;
      if (!schoolId) return true;
      var target = String(schoolId);
      var schoolIds = [];
      if ((user === null || user === void 0 || (_user$school2 = user.school) === null || _user$school2 === void 0 ? void 0 : _user$school2.id) !== undefined && (user === null || user === void 0 || (_user$school3 = user.school) === null || _user$school3 === void 0 ? void 0 : _user$school3.id) !== null) schoolIds.push(String(user.school.id));
      if ((user === null || user === void 0 ? void 0 : user.schoolId) !== undefined && (user === null || user === void 0 ? void 0 : user.schoolId) !== null) schoolIds.push(String(user.schoolId));
      if (Array.isArray(user === null || user === void 0 ? void 0 : user.schools)) {
        user.schools.forEach(function (item) {
          if ((item === null || item === void 0 ? void 0 : item.id) !== undefined && (item === null || item === void 0 ? void 0 : item.id) !== null) schoolIds.push(String(item.id));
        });
      }
      if (Array.isArray(user === null || user === void 0 ? void 0 : user.additionalSchoolIds)) {
        user.additionalSchoolIds.forEach(function (id) {
          if (id !== undefined && id !== null) schoolIds.push(String(id));
        });
      }
      if (schoolIds.length === 0) return true;
      return schoolIds.includes(target);
    },
    matchesUserDept: function matchesUserDept(user, deptId) {
      if (!deptId) return true;
      var target = String(deptId);
      var deptIds = [];
      if ((user === null || user === void 0 ? void 0 : user.deptId) !== undefined && (user === null || user === void 0 ? void 0 : user.deptId) !== null) deptIds.push(String(user.deptId));
      if (Array.isArray(user === null || user === void 0 ? void 0 : user.depts)) {
        user.depts.forEach(function (item) {
          if ((item === null || item === void 0 ? void 0 : item.id) !== undefined && (item === null || item === void 0 ? void 0 : item.id) !== null) deptIds.push(String(item.id));
        });
      }
      if (Array.isArray(user === null || user === void 0 ? void 0 : user.additionalDeptIds)) {
        user.additionalDeptIds.forEach(function (id) {
          if (id !== undefined && id !== null) deptIds.push(String(id));
        });
      }
      return deptIds.includes(target);
    },
    matchesContactType: function matchesContactType(user) {
      var _user$post2;
      var roleNames = [user === null || user === void 0 || (_user$post2 = user.post) === null || _user$post2 === void 0 ? void 0 : _user$post2.name].concat(_toConsumableArray(Array.isArray(user === null || user === void 0 ? void 0 : user.roles) ? user.roles.map(function (role) {
        return (role === null || role === void 0 ? void 0 : role.displayName) || (role === null || role === void 0 ? void 0 : role.name);
      }) : [])).filter(Boolean).join(' ');
      if (this.selectedContactType === 'teacher') {
        return !/学生|家长|供应商/i.test(roleNames);
      }
      if (this.selectedContactType === 'student') {
        return /学生/i.test(roleNames);
      }
      if (this.selectedContactType === 'parent') {
        return /家长/i.test(roleNames);
      }
      if (this.selectedContactType === 'supplier') {
        return /供应商/i.test(roleNames);
      }
      return true;
    },
    getGroupAvatarTokens: function getGroupAvatarTokens(chat) {
      var source = String((chat === null || chat === void 0 ? void 0 : chat.name) || '').replace(/\s+/g, '').replace(/[、,，.。·\-_/\\|]/g, '').trim();
      if (!source) return ['群', '聊', '室', '群'];
      var chars = Array.from(source).filter(Boolean);
      if (chars.length >= 4) return chars.slice(0, 4);
      if (chars.length === 3) return [chars[0], chars[1], chars[2], '群'];
      if (chars.length === 2) return [chars[0], chars[1], '聊', '群'];
      return [chars[0], '群', '聊', '室'];
    },
    matchesChatFilter: function matchesChatFilter(chat) {
      if (this.listFilter === 'all') return true;
      return this.getChatCategory(chat) === this.listFilter;
    },
    matchesChatKeyword: function matchesChatKeyword(chat, keyword) {
      var fields = [chat.name, chat.lastMessage, this.formatLastMessage(chat)];
      var historyMatched = !!this.findHistoryMatch(chat, keyword);
      return fields.some(function (text) {
        return String(text || '').toLowerCase().includes(keyword);
      }) || historyMatched;
    },
    findHistoryMatch: function findHistoryMatch(chat) {
      var keyword = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var target = (keyword || this.listSearchKeyword || '').trim().toLowerCase();
      if (!target) return null;
      var history = this.messages[chat.id] || [];
      return history.find(function (msg) {
        return String(msg.content || '').toLowerCase().includes(target);
      }) || null;
    },
    hasHistoryMatch: function hasHistoryMatch(chat) {
      var keyword = (this.listSearchKeyword || '').trim();
      if (!keyword) return false;
      var lastPreview = this.formatLastMessage(chat).toLowerCase();
      if (lastPreview.includes(keyword.toLowerCase())) return false;
      return !!this.findHistoryMatch(chat, keyword);
    },
    getChatPreview: function getChatPreview(chat) {
      if (!this.hasHistoryMatch(chat)) return this.formatLastMessage(chat);
      var matched = this.findHistoryMatch(chat);
      if (!matched) return this.formatLastMessage(chat);
      var text = this.formatPlainPreview(matched.content);
      return text ? "\u5386\u53F2: ".concat(text.length > 24 ? text.slice(0, 24) + '...' : text) : this.formatLastMessage(chat);
    },
    formatLastMessage: function formatLastMessage(chat) {
      var msg = chat.lastMessage || '';
      if (msg === '已撤回' || msg === '撤回了一条消息') return '撤回了一条消息';
      if (this.hasMentionForMe(msg)) {
        var preview = this.formatPlainPreview(msg);
        return preview ? "[\u6709\u4EBA@\u4F60] ".concat(preview) : '[有人@你]';
      }
      try {
        var json = JSON.parse(msg);
        var card = this.normalizeCard(json);
        if (card.type) {
          return "[\u5361\u7247] ".concat(card.title || card.summary || '');
        }
      } catch (_) {
        // ignore invalid card payload
      }
      if (chat.lastMessageType === 2 || chat.messageType === 2) return '[图片]';
      if (chat.lastMessageType === 4 || chat.messageType === 4) return '[语音]';
      if (chat.lastMessageType === 3 || chat.messageType === 3) return '[视频]';
      return this.formatPlainPreview(msg);
    },
    openChat: function openChat(chat) {
      var _this13 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8() {
        var _t2;
        return _regenerator().w(function (_context8) {
          while (1) switch (_context8.p = _context8.n) {
            case 0:
              _this13.selectedChat = chat;
              _this13.groupMembers = [];
              _this13.groupMembersChatId = null;
              _this13.groupNoticeDetail = null;
              _this13.nearBottom = true;
              _this13.newMessageHintCount = 0;
              if (!_this13.isGroupChat(chat)) {
                _context8.n = 4;
                break;
              }
              _context8.p = 1;
              _context8.n = 2;
              return _this13.ensureSelectedGroupMembersLoaded();
            case 2:
              _context8.n = 4;
              break;
            case 3:
              _context8.p = 3;
              _t2 = _context8.v;
              console.warn('[ImChat] preload group members failed:', _t2);
            case 4:
              _this13.view = 'messages';
              _context8.n = 5;
              return _this13.$store.dispatch('chat/selectChat', chat.id);
            case 5:
              // 等消息加载完毕后再滚动，双 nextTick 保证 DOM 已渲染
              _this13.$nextTick(function () {
                _this13.$nextTick(function () {
                  return _this13.scrollToBottom();
                });
              });

              // 上报已读
              if (chat.maxSeq) {
                _this13.$store.dispatch('chat/reportRead', {
                  chatId: chat.id,
                  readSeq: chat.maxSeq
                });
              }
            case 6:
              return _context8.a(2);
          }
        }, _callee8, null, [[1, 3]]);
      }))();
    },
    openGroupDetail: function openGroupDetail() {
      var _this14 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9() {
        return _regenerator().w(function (_context9) {
          while (1) switch (_context9.n) {
            case 0:
              if (!(!_this14.selectedChat || !_this14.selectedChatIsGroup)) {
                _context9.n = 1;
                break;
              }
              return _context9.a(2);
            case 1:
              _this14.view = 'groupDetail';
              _context9.n = 2;
              return _this14.loadGroupDetail();
            case 2:
              return _context9.a(2);
          }
        }, _callee9);
      }))();
    },
    loadGroupDetail: function loadGroupDetail() {
      var _this15 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee0() {
        var _yield$Promise$all, _yield$Promise$all2, members, noticeRes, _t3;
        return _regenerator().w(function (_context0) {
          while (1) switch (_context0.p = _context0.n) {
            case 0:
              if (!(!_this15.selectedChat || !_this15.selectedChatIsGroup)) {
                _context0.n = 1;
                break;
              }
              return _context0.a(2);
            case 1:
              _this15.groupDetailLoading = true;
              _context0.p = 2;
              _context0.n = 3;
              return Promise.all([_this15.fetchGroupMembers(_this15.selectedChat.id), getGroupNotice({
                chatId: _this15.selectedChat.id
              })]);
            case 3:
              _yield$Promise$all = _context0.v;
              _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 2);
              members = _yield$Promise$all2[0];
              noticeRes = _yield$Promise$all2[1];
              _this15.groupNoticeDetail = (noticeRes === null || noticeRes === void 0 ? void 0 : noticeRes.data) || noticeRes || null;
              _context0.n = 5;
              break;
            case 4:
              _context0.p = 4;
              _t3 = _context0.v;
              _this15.$message.error((_t3 === null || _t3 === void 0 ? void 0 : _t3.message) || '加载群详情失败');
            case 5:
              _context0.p = 5;
              _this15.groupDetailLoading = false;
              return _context0.f(5);
            case 6:
              return _context0.a(2);
          }
        }, _callee0, null, [[2, 4, 5, 6]]);
      }))();
    },
    openAllGroupMembers: function openAllGroupMembers() {
      if (!this.selectedChatIsGroup) return;
      this.view = 'groupMembers';
    },
    isCurrentGroupMember: function isCurrentGroupMember(member) {
      if (!member) return false;
      var myId = String(this.userId || '').trim();
      var memberId = String(member.userId || '').trim();
      if (myId && memberId && myId === memberId) return true;
      var myName = String(this.userName || '').trim();
      var memberName = String(member.userName || '').trim();
      if (myName && memberName && myName === memberName) return true;
      return false;
    },
    getGroupMemberActions: function getGroupMemberActions(member) {
      var _member$role;
      if (!this.selectedChatIsGroup || !member) return [];
      if (this.isCurrentGroupMember(member)) return [];
      var currentRole = Number(this.currentUserGroupRole);
      var targetRole = Number((_member$role = member.role) !== null && _member$role !== void 0 ? _member$role : -1);
      if (currentRole === 1) {
        if (targetRole === 1) return [];
        var actions = [];
        if (targetRole === 2) {
          actions.push({
            key: 'unset-admin',
            label: '取消管理员'
          });
        } else {
          actions.push({
            key: 'set-admin',
            label: '设为管理员'
          });
        }
        actions.push({
          key: 'transfer-owner',
          label: '转让群主'
        });
        actions.push({
          key: member.isMuted ? 'unmute' : 'mute',
          label: member.isMuted ? '解除禁言' : '禁言成员'
        });
        actions.push({
          key: 'remove-member',
          label: '移除成员'
        });
        return actions;
      }
      if (currentRole === 2 && targetRole === 0) {
        return [{
          key: member.isMuted ? 'unmute' : 'mute',
          label: member.isMuted ? '解除禁言' : '禁言成员'
        }, {
          key: 'remove-member',
          label: '移除成员'
        }];
      }
      return [];
    },
    handleGroupMemberAction: function handleGroupMemberAction(actionKey, member) {
      var _this16 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee1() {
        var chatId, memberId, memberName, isMuted, _t4;
        return _regenerator().w(function (_context1) {
          while (1) switch (_context1.p = _context1.n) {
            case 0:
              if (!(!_this16.selectedChat || !actionKey || !member)) {
                _context1.n = 1;
                break;
              }
              return _context1.a(2);
            case 1:
              chatId = _this16.selectedChat.id;
              memberId = member.userId;
              memberName = member.userName || '该成员';
              _context1.p = 2;
              if (!(actionKey === 'set-admin')) {
                _context1.n = 4;
                break;
              }
              _context1.n = 3;
              return updateGroupAdmin({
                chatId: chatId,
                userId: memberId,
                isAdmin: true
              });
            case 3:
              _this16.$message.success("\u5DF2\u5C06".concat(memberName, "\u8BBE\u4E3A\u7BA1\u7406\u5458"));
              _context1.n = 15;
              break;
            case 4:
              if (!(actionKey === 'unset-admin')) {
                _context1.n = 6;
                break;
              }
              _context1.n = 5;
              return updateGroupAdmin({
                chatId: chatId,
                userId: memberId,
                isAdmin: false
              });
            case 5:
              _this16.$message.success("\u5DF2\u53D6\u6D88".concat(memberName, "\u7684\u7BA1\u7406\u5458\u8EAB\u4EFD"));
              _context1.n = 15;
              break;
            case 6:
              if (!(actionKey === 'transfer-owner')) {
                _context1.n = 9;
                break;
              }
              _context1.n = 7;
              return _this16.$confirm("\u786E\u5B9A\u5C06\u7FA4\u4E3B\u8F6C\u8BA9\u7ED9".concat(memberName, "\u5417\uFF1F"), '转让群主', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              });
            case 7:
              _context1.n = 8;
              return transferGroupOwner({
                chatId: chatId,
                userId: memberId
              });
            case 8:
              _this16.$message.success("\u5DF2\u5C06\u7FA4\u4E3B\u8F6C\u8BA9\u7ED9".concat(memberName));
              _context1.n = 15;
              break;
            case 9:
              if (!(actionKey === 'mute' || actionKey === 'unmute')) {
                _context1.n = 11;
                break;
              }
              isMuted = actionKey === 'mute';
              _context1.n = 10;
              return updateGroupMemberMute({
                chatId: chatId,
                userId: memberId,
                isMuted: isMuted
              });
            case 10:
              _this16.$message.success(isMuted ? "\u5DF2\u7981\u8A00".concat(memberName) : "\u5DF2\u89E3\u9664".concat(memberName, "\u7684\u7981\u8A00"));
              _context1.n = 15;
              break;
            case 11:
              if (!(actionKey === 'remove-member')) {
                _context1.n = 14;
                break;
              }
              _context1.n = 12;
              return _this16.$confirm("\u786E\u5B9A\u5C06".concat(memberName, "\u79FB\u51FA\u7FA4\u804A\u5417\uFF1F"), '移除成员', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              });
            case 12:
              _context1.n = 13;
              return removeGroupMember({
                chatId: chatId,
                userId: memberId
              });
            case 13:
              _this16.$message.success("\u5DF2\u79FB\u9664".concat(memberName));
              _context1.n = 15;
              break;
            case 14:
              return _context1.a(2);
            case 15:
              _context1.n = 16;
              return _this16.loadGroupDetail();
            case 16:
              _context1.n = 19;
              break;
            case 17:
              _context1.p = 17;
              _t4 = _context1.v;
              if (!(_t4 === 'cancel' || _t4 === 'close')) {
                _context1.n = 18;
                break;
              }
              return _context1.a(2);
            case 18:
              _this16.$message.error((_t4 === null || _t4 === void 0 ? void 0 : _t4.message) || '操作失败');
            case 19:
              return _context1.a(2);
          }
        }, _callee1, null, [[2, 17]]);
      }))();
    },
    handleGroupAction: function handleGroupAction(item) {
      if (!item) return;
      if (item.key === 'notice') {
        this.handleGroupNotice();
        return;
      }
      if (item.key === 'name') {
        this.handleGroupNameEdit();
        return;
      }
      if (item.key === 'mute') {
        this.handleGroupAllMute();
        return;
      }
      this.$message.info('Web 端这项编辑能力下一步继续补');
    },
    normalizeGroupMembers: function normalizeGroupMembers(rawMembers) {
      return (Array.isArray(rawMembers) ? rawMembers : []).map(function (member) {
        var _member$role2;
        return _objectSpread(_objectSpread({}, member), {}, {
          role: Number((_member$role2 = member.role) !== null && _member$role2 !== void 0 ? _member$role2 : -1),
          isMuted: Number(member.isMuted || 0) === 1
        });
      });
    },
    fetchGroupMembers: function fetchGroupMembers(chatId) {
      var _this17 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee10() {
        var _this17$selectedChat;
        var memberRes, rawMembers, members;
        return _regenerator().w(function (_context10) {
          while (1) switch (_context10.n) {
            case 0:
              _context10.n = 1;
              return getGroupMembers({
                chatId: chatId
              });
            case 1:
              memberRes = _context10.v;
              rawMembers = Array.isArray(memberRes === null || memberRes === void 0 ? void 0 : memberRes.data) ? memberRes.data : Array.isArray(memberRes) ? memberRes : [];
              members = _this17.normalizeGroupMembers(rawMembers);
              if (((_this17$selectedChat = _this17.selectedChat) === null || _this17$selectedChat === void 0 ? void 0 : _this17$selectedChat.id) === chatId) {
                _this17.groupMembers = members;
                _this17.groupMembersChatId = chatId;
              }
              return _context10.a(2, members);
          }
        }, _callee10);
      }))();
    },
    ensureSelectedGroupMembersLoaded: function ensureSelectedGroupMembersLoaded() {
      var _arguments = arguments,
        _this18 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee11() {
        var _this18$selectedChat;
        var force, chatId;
        return _regenerator().w(function (_context11) {
          while (1) switch (_context11.n) {
            case 0:
              force = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : false;
              if (!(!_this18.selectedChatIsGroup || !((_this18$selectedChat = _this18.selectedChat) !== null && _this18$selectedChat !== void 0 && _this18$selectedChat.id))) {
                _context11.n = 1;
                break;
              }
              return _context11.a(2, []);
            case 1:
              chatId = _this18.selectedChat.id;
              if (!(!force && _this18.groupMembersChatId === chatId && _this18.groupMembers.length > 0)) {
                _context11.n = 2;
                break;
              }
              return _context11.a(2, _this18.groupMembers);
            case 2:
              return _context11.a(2, _this18.fetchGroupMembers(chatId));
          }
        }, _callee11);
      }))();
    },
    handleGroupNotice: function handleGroupNotice() {
      var _this$groupNoticeDeta2,
        _this19 = this;
      if (!this.selectedChatIsGroup || !this.selectedChat) return;
      var currentNotice = ((_this$groupNoticeDeta2 = this.groupNoticeDetail) === null || _this$groupNoticeDeta2 === void 0 ? void 0 : _this$groupNoticeDeta2.notice) || '';
      if (!this.canEditGroupInfo) {
        var _this$groupNoticeDeta3, _this$groupNoticeDeta4;
        var updater = (_this$groupNoticeDeta3 = this.groupNoticeDetail) !== null && _this$groupNoticeDeta3 !== void 0 && _this$groupNoticeDeta3.updatedUserName ? "\u66F4\u65B0\u4EBA\uFF1A".concat(this.groupNoticeDetail.updatedUserName, "<br/>") : '';
        var updatedTime = (_this$groupNoticeDeta4 = this.groupNoticeDetail) !== null && _this$groupNoticeDeta4 !== void 0 && _this$groupNoticeDeta4.updatedTime ? "\u6700\u8FD1\u66F4\u65B0\uFF1A".concat(this.formatAbsoluteTime(this.groupNoticeDetail.updatedTime), "<br/><br/>") : '';
        var notice = this.escapeHtml(currentNotice || '暂无群公告').replace(/\n/g, '<br>');
        this.$alert("".concat(updater).concat(updatedTime).concat(notice), '群公告', {
          dangerouslyUseHTMLString: true,
          confirmButtonText: '知道了'
        });
        return;
      }
      this.$prompt('请输入群公告内容', '编辑群公告', {
        confirmButtonText: '保存',
        cancelButtonText: '取消',
        inputType: 'textarea',
        inputValue: currentNotice,
        inputPlaceholder: '请输入群公告',
        inputValidator: function inputValidator(value) {
          if (String(value || '').trim().length > 500) {
            return '群公告不能超过 500 字';
          }
          return true;
        }
      }).then(/*#__PURE__*/function () {
        var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee12(_ref2) {
          var value, res, detail, _t5;
          return _regenerator().w(function (_context12) {
            while (1) switch (_context12.p = _context12.n) {
              case 0:
                value = _ref2.value;
                _context12.p = 1;
                _context12.n = 2;
                return updateGroupNotice({
                  chatId: _this19.selectedChat.id,
                  notice: String(value || '').trim()
                });
              case 2:
                res = _context12.v;
                detail = (res === null || res === void 0 ? void 0 : res.data) || res || {};
                _this19.groupNoticeDetail = detail;
                _this19.$message.success('群公告已更新');
                _context12.n = 4;
                break;
              case 3:
                _context12.p = 3;
                _t5 = _context12.v;
                _this19.$message.error((_t5 === null || _t5 === void 0 ? void 0 : _t5.message) || '更新群公告失败');
              case 4:
                return _context12.a(2);
            }
          }, _callee12, null, [[1, 3]]);
        }));
        return function (_x) {
          return _ref3.apply(this, arguments);
        };
      }()).catch(function () {});
    },
    handleGroupNameEdit: function handleGroupNameEdit() {
      var _this$selectedChat6,
        _this20 = this;
      if (!this.selectedChatIsGroup || !this.selectedChat || !this.canEditGroupInfo) return;
      this.$prompt('请输入新的群聊名称', '修改群名称', {
        confirmButtonText: '保存',
        cancelButtonText: '取消',
        inputValue: ((_this$selectedChat6 = this.selectedChat) === null || _this$selectedChat6 === void 0 ? void 0 : _this$selectedChat6.name) || '',
        inputPlaceholder: '请输入群名称',
        inputValidator: function inputValidator(value) {
          var text = String(value || '').trim();
          if (!text) return '群名称不能为空';
          if (text.length > 30) return '群名称不能超过 30 字';
          return true;
        }
      }).then(/*#__PURE__*/function () {
        var _ref5 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee13(_ref4) {
          var value, name, _this20$selectedChat, res, updatedChat, _t6;
          return _regenerator().w(function (_context13) {
            while (1) switch (_context13.p = _context13.n) {
              case 0:
                value = _ref4.value;
                name = String(value || '').trim();
                _context13.p = 1;
                _context13.n = 2;
                return updateGroupInfo({
                  chatId: _this20.selectedChat.id,
                  name: name,
                  avatar: ((_this20$selectedChat = _this20.selectedChat) === null || _this20$selectedChat === void 0 ? void 0 : _this20$selectedChat.avatar) || ''
                });
              case 2:
                res = _context13.v;
                updatedChat = (res === null || res === void 0 ? void 0 : res.data) || res || {};
                _this20.applyGroupChatMeta(updatedChat);
                _this20.$message.success('群名称已更新');
                _context13.n = 4;
                break;
              case 3:
                _context13.p = 3;
                _t6 = _context13.v;
                _this20.$message.error((_t6 === null || _t6 === void 0 ? void 0 : _t6.message) || '更新群名称失败');
              case 4:
                return _context13.a(2);
            }
          }, _callee13, null, [[1, 3]]);
        }));
        return function (_x2) {
          return _ref5.apply(this, arguments);
        };
      }()).catch(function () {});
    },
    handleGroupAvatarClick: function handleGroupAvatarClick() {
      if (!this.canEditGroupInfo || !this.selectedChatIsGroup) return;
      this.$refs.groupAvatarInput && this.$refs.groupAvatarInput.click();
    },
    handleGroupAvatarFileChange: function handleGroupAvatarFileChange(event) {
      var _this21 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee14() {
        var file, isImage, isLt5M, formData, res, imageUrl, updateRes, updatedChat, _t7;
        return _regenerator().w(function (_context14) {
          while (1) switch (_context14.p = _context14.n) {
            case 0:
              file = event.target.files[0];
              if (file) {
                _context14.n = 1;
                break;
              }
              return _context14.a(2);
            case 1:
              isImage = file.type.startsWith('image/');
              isLt5M = file.size / 1024 / 1024 < 5;
              if (isImage) {
                _context14.n = 2;
                break;
              }
              _this21.$message.error('只能上传图片文件');
              _this21.$refs.groupAvatarInput.value = '';
              return _context14.a(2);
            case 2:
              if (isLt5M) {
                _context14.n = 3;
                break;
              }
              _this21.$message.error('图片大小不能超过 5MB');
              _this21.$refs.groupAvatarInput.value = '';
              return _context14.a(2);
            case 3:
              _context14.p = 3;
              formData = new FormData();
              formData.append('file', file);
              _context14.n = 4;
              return uploadImage(formData);
            case 4:
              res = _context14.v;
              imageUrl = res.data || res.url || res;
              if (!(imageUrl && typeof imageUrl === 'string')) {
                _context14.n = 6;
                break;
              }
              _context14.n = 5;
              return updateGroupInfo({
                chatId: _this21.selectedChat.id,
                name: _this21.selectedChat.name,
                avatar: imageUrl
              });
            case 5:
              updateRes = _context14.v;
              updatedChat = (updateRes === null || updateRes === void 0 ? void 0 : updateRes.data) || updateRes || {};
              _this21.applyGroupChatMeta(updatedChat);
              _this21.$message.success('群头像已更新');
            case 6:
              _context14.n = 8;
              break;
            case 7:
              _context14.p = 7;
              _t7 = _context14.v;
              _this21.$message.error((_t7 === null || _t7 === void 0 ? void 0 : _t7.message) || '上传群头像失败');
            case 8:
              _context14.p = 8;
              _this21.$refs.groupAvatarInput.value = '';
              return _context14.f(8);
            case 9:
              return _context14.a(2);
          }
        }, _callee14, null, [[3, 7, 8, 9]]);
      }))();
    },
    handleGroupAllMute: function handleGroupAllMute() {
      var _this$selectedChat7,
        _this22 = this;
      if (!this.selectedChatIsGroup || !this.selectedChat || !this.canInviteGroupMember) return;
      var nextValue = !((_this$selectedChat7 = this.selectedChat) !== null && _this$selectedChat7 !== void 0 && _this$selectedChat7.isAllMuted);
      var actionText = nextValue ? '开启全员禁言' : '关闭全员禁言';
      var detailText = nextValue ? '开启后仅群主和管理员可发言' : '关闭后所有成员可正常发言';
      this.$confirm(detailText, actionText, {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee15() {
        var res, updatedChat, _t8;
        return _regenerator().w(function (_context15) {
          while (1) switch (_context15.p = _context15.n) {
            case 0:
              _context15.p = 0;
              _context15.n = 1;
              return updateGroupAllMute({
                chatId: _this22.selectedChat.id,
                isAllMuted: nextValue
              });
            case 1:
              res = _context15.v;
              updatedChat = (res === null || res === void 0 ? void 0 : res.data) || res || {};
              _this22.applyGroupChatMeta(updatedChat);
              _this22.$message.success("".concat(actionText, "\u6210\u529F"));
              _context15.n = 3;
              break;
            case 2:
              _context15.p = 2;
              _t8 = _context15.v;
              _this22.$message.error((_t8 === null || _t8 === void 0 ? void 0 : _t8.message) || "".concat(actionText, "\u5931\u8D25"));
            case 3:
              return _context15.a(2);
          }
        }, _callee15, null, [[0, 2]]);
      }))).catch(function () {});
    },
    applyGroupChatMeta: function applyGroupChatMeta(updatedChat) {
      if (!updatedChat || !this.selectedChat) return;
      var patch = {};
      if (updatedChat.name !== undefined) patch.name = updatedChat.name;
      if (updatedChat.avatar !== undefined) patch.avatar = updatedChat.avatar;
      if (updatedChat.lastMessage !== undefined) patch.lastMessage = updatedChat.lastMessage;
      if (updatedChat.lastMessageTime !== undefined) patch.lastMessageTime = updatedChat.lastMessageTime;
      if (updatedChat.maxSeq !== undefined) patch.maxSeq = updatedChat.maxSeq;
      if (updatedChat.isAllMuted !== undefined) patch.isAllMuted = !!updatedChat.isAllMuted;
      if (Object.keys(patch).length === 0) return;
      this.selectedChat = _objectSpread(_objectSpread({}, this.selectedChat), patch);
      this.$store.commit('chat/UPDATE_CHAT_META', {
        chatId: this.selectedChat.id,
        patch: patch
      });
    },
    getGroupRoleLabel: function getGroupRoleLabel(role) {
      if (role === 1) return '群主';
      if (role === 2) return '管理员';
      return '成员';
    },
    formatAbsoluteTime: function formatAbsoluteTime(time) {
      var d = dayjs(time);
      if (!d.isValid()) return '';
      return d.format('YYYY-MM-DD HH:mm');
    },
    // 消息
    isMyMessage: function isMyMessage(msg) {
      return msg.senderId === this.userId || String(msg.senderId) === String(this.userId);
    },
    getMsgAvatar: function getMsgAvatar(msg) {
      // 优先用消息自带头像，fallback 到会话头像
      var avatar = msg.senderAvatar || msg.SenderAvatar;
      if (avatar) return avatar;
      var chat = this.selectedChat;
      return (chat === null || chat === void 0 ? void 0 : chat.avatar) || '';
    },
    getMessageAvatarFallback: function getMessageAvatarFallback(msg) {
      if ((msg === null || msg === void 0 ? void 0 : msg.senderType) === 0) {
        var name = String((msg === null || msg === void 0 ? void 0 : msg.senderName) || '');
        if (name.includes('审批')) return '审';
        if (name.includes('通知')) return '通';
        return '助';
      }
      return ((msg === null || msg === void 0 ? void 0 : msg.senderName) || '?')[0];
    },
    getGroupDetailAvatarText: function getGroupDetailAvatarText() {
      var _this$selectedChat8;
      if ((_this$selectedChat8 = this.selectedChat) !== null && _this$selectedChat8 !== void 0 && _this$selectedChat8.avatar) return '';
      return this.getAvatarFallback(this.selectedChat);
    },
    beforeImageUpload: function beforeImageUpload(file) {
      if (!this.canCurrentUserSendInSelectedChat) {
        this.$message.warning(this.currentUserGroupMuted ? '你已被禁言，暂时无法发言' : '当前群聊已开启全员禁言');
        return false;
      }
      var isImage = file.type.startsWith('image/');
      var isLt5M = file.size / 1024 / 1024 < 5;
      if (!isImage) this.$message.error('只能上传图片文件');
      if (!isLt5M) this.$message.error('图片大小不能超过 5MB');
      return isImage && isLt5M;
    },
    handleImageUpload: function handleImageUpload(response) {
      var _this23 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee16() {
        var imageUrl;
        return _regenerator().w(function (_context16) {
          while (1) switch (_context16.n) {
            case 0:
              if (_this23.canCurrentUserSendInSelectedChat) {
                _context16.n = 1;
                break;
              }
              _this23.$message.warning(_this23.currentUserGroupMuted ? '你已被禁言，暂时无法发言' : '当前群聊已开启全员禁言');
              return _context16.a(2);
            case 1:
              imageUrl = response.data || response.url;
              if (!(!imageUrl || !_this23.currentChatId)) {
                _context16.n = 2;
                break;
              }
              return _context16.a(2);
            case 2:
              _context16.n = 3;
              return _this23.$store.dispatch('chat/sendImageMessage', {
                chatId: _this23.currentChatId,
                imageUrl: imageUrl
              });
            case 3:
              _this23.$nextTick(function () {
                return _this23.scrollToBottom();
              });
            case 4:
              return _context16.a(2);
          }
        }, _callee16);
      }))();
    },
    retryMessage: function retryMessage(msg) {
      var _this24 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee17() {
        return _regenerator().w(function (_context17) {
          while (1) switch (_context17.n) {
            case 0:
              if (!(!_this24.currentChatId || !msg || msg._pending)) {
                _context17.n = 1;
                break;
              }
              return _context17.a(2);
            case 1:
              _context17.n = 2;
              return _this24.$store.dispatch('chat/retryMessage', {
                chatId: _this24.currentChatId,
                message: msg
              });
            case 2:
              _this24.$nextTick(function () {
                return _this24.scrollToBottom();
              });
            case 3:
              return _context17.a(2);
          }
        }, _callee17);
      }))();
    },
    isStructuredCardMessage: function isStructuredCardMessage(msg) {
      var payload = this.getCardPayload(msg);
      return (payload === null || payload === void 0 ? void 0 : payload._isStructuredCard) === true;
    },
    isApprovalCard: function isApprovalCard(msg) {
      if (!this.isStructuredCardMessage(msg)) return false;
      try {
        var payload = this.getCardPayload(msg);
        return ['approval', 'approve', 'workflow', 'todo'].includes(String(payload.type || '').toLowerCase());
      } catch (_) {
        return false;
      }
    },
    isCardMessage: function isCardMessage(msg) {
      return this.isApprovalCard(msg) || this.isGenericCard(msg);
    },
    isAssistantCardMessage: function isAssistantCardMessage(msg) {
      return !!msg && msg.senderType === 0 && this.isCardMessage(msg);
    },
    isGenericCard: function isGenericCard(msg) {
      if (!this.isStructuredCardMessage(msg)) return false;
      try {
        var payload = this.getCardPayload(msg);
        return !['approval', 'approve', 'workflow', 'todo'].includes(String(payload.type || '').toLowerCase());
      } catch (_) {
        return false;
      }
    },
    getCardPayload: function getCardPayload(msg) {
      try {
        if (msg && msg._cardPayload) {
          if (msg._cardPayload._isStructuredCard !== true) return {};
          return msg._cardPayload;
        }
        var content = msg === null || msg === void 0 ? void 0 : msg.content;
        var raw = null;
        var parsedFromStructuredContent = false;
        if (content && _typeof(content) === 'object') {
          raw = content;
          parsedFromStructuredContent = true;
        } else if (typeof content === 'string') {
          var trimmed = content.trim();
          if (trimmed.startsWith('{') || trimmed.startsWith('[')) {
            raw = JSON.parse(trimmed);
            parsedFromStructuredContent = true;
          }
        }
        var normalized = this.normalizeCard(raw || {}, msg.link, msg);
        if (!parsedFromStructuredContent || !normalized._isStructuredCard) {
          return {};
        }
        return normalized;
      } catch (_) {
        return {};
      }
    },
    resolveCardType: function resolveCardType(card) {
      return (card === null || card === void 0 ? void 0 : card.type) || (card === null || card === void 0 ? void 0 : card.cardType) || (card === null || card === void 0 ? void 0 : card.Type) || (card === null || card === void 0 ? void 0 : card.CardType) || '';
    },
    normalizeKeys: function normalizeKeys(value) {
      var _this25 = this;
      if (Array.isArray(value)) {
        return value.map(function (item) {
          return _this25.normalizeKeys(item);
        });
      }
      if (value && _typeof(value) === 'object') {
        return Object.keys(value).reduce(function (acc, key) {
          acc[(key || '').toLowerCase()] = _this25.normalizeKeys(value[key]);
          return acc;
        }, {});
      }
      return value;
    },
    normalizeCard: function normalizeCard(card) {
      var fallbackLink = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var message = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var normalized = this.normalizeKeys(card);
      var extra = normalized.extra || {};
      var actions = Array.isArray(normalized.actions) ? normalized.actions : [];
      var deepLink = normalized.deeplink || extra.deeplink || fallbackLink || extra.link || extra.applink || (message === null || message === void 0 ? void 0 : message.link) || '';
      var messageTitle = (message === null || message === void 0 ? void 0 : message.title) || (message === null || message === void 0 ? void 0 : message.Title) || '';
      var inferredType = normalized.type || normalized.cardtype || '';
      var hasStructuredMarker = !!inferredType || !!normalized.cardtype || !!normalized.type || !!normalized.actions || !!normalized.extra || !!normalized.processid || !!normalized.bizid || !!normalized.biztype || !!normalized.currenthandler || !!normalized.initiatorname || !!normalized.actiontext;
      return {
        _isStructuredCard: hasStructuredMarker,
        type: inferredType || (hasStructuredMarker ? 'card' : ''),
        title: normalized.title || extra.title || extra.processname || messageTitle || '',
        summary: normalized.summary || normalized.actiontext || extra.actiontext || '',
        status: normalized.status || '',
        actions: actions.map(function (action) {
          return {
            key: action.key,
            text: action.text,
            deepLink: action.deeplink
          };
        }),
        deepLink: deepLink,
        extra: {
          processId: normalized.processid || extra.processid,
          bizId: normalized.bizid || extra.bizid,
          bizType: normalized.biztype || extra.biztype,
          initiatorName: normalized.initiatorname || extra.initiatorname,
          currentHandler: normalized.currenthandler || extra.currenthandler,
          actionText: normalized.actiontext || extra.actiontext,
          createdTime: normalized.createdtime || normalized.occurredat || extra.createdtime || extra.occurredat,
          deepLink: deepLink
        }
      };
    },
    openApprovalDetail: function openApprovalDetail(card) {
      var _card$extra, _card$actions;
      var deepLink = (card === null || card === void 0 || (_card$extra = card.extra) === null || _card$extra === void 0 ? void 0 : _card$extra.deepLink) || (card === null || card === void 0 || (_card$actions = card.actions) === null || _card$actions === void 0 || (_card$actions = _card$actions.find(function (action) {
        return action && action.deepLink;
      })) === null || _card$actions === void 0 ? void 0 : _card$actions.deepLink);
      if (deepLink) {
        this.handleClose();
        this.$router.push(deepLink);
      }
    },
    openCardDetail: function openCardDetail(card) {
      var _card$extra2, _card$actions2;
      var deepLink = (card === null || card === void 0 ? void 0 : card.deepLink) || (card === null || card === void 0 || (_card$extra2 = card.extra) === null || _card$extra2 === void 0 ? void 0 : _card$extra2.deepLink) || (card === null || card === void 0 || (_card$actions2 = card.actions) === null || _card$actions2 === void 0 || (_card$actions2 = _card$actions2.find(function (action) {
        return action && action.deepLink;
      })) === null || _card$actions2 === void 0 ? void 0 : _card$actions2.deepLink);
      if (deepLink) {
        this.handleClose();
        this.$router.push(deepLink);
      }
    },
    sendMessage: function sendMessage() {
      var _this26 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee18() {
        var content;
        return _regenerator().w(function (_context18) {
          while (1) switch (_context18.n) {
            case 0:
              content = _this26.inputText.trim();
              if (!(!content || !_this26.currentChatId)) {
                _context18.n = 1;
                break;
              }
              return _context18.a(2);
            case 1:
              if (_this26.canCurrentUserSendInSelectedChat) {
                _context18.n = 2;
                break;
              }
              _this26.$message.warning(_this26.currentUserGroupMuted ? '你已被禁言，暂时无法发言' : '当前群聊已开启全员禁言');
              return _context18.a(2);
            case 2:
              _this26.inputText = '';
              _context18.n = 3;
              return _this26.$store.dispatch('chat/sendMessage', {
                chatId: _this26.currentChatId,
                content: content
              });
            case 3:
              _this26.$nextTick(function () {
                return _this26.scrollToBottom();
              });
            case 4:
              return _context18.a(2);
          }
        }, _callee18);
      }))();
    },
    insertEmoji: function insertEmoji(emoji) {
      if (!this.canCurrentUserSendInSelectedChat) return;
      var textarea = this.$refs.msgInput.$refs.textarea;
      var startPos = textarea.selectionStart;
      var endPos = textarea.selectionEnd;
      var currentText = this.inputText || '';
      this.inputText = currentText.substring(0, startPos) + emoji + currentText.substring(endPos);
      this.$nextTick(function () {
        textarea.selectionStart = startPos + emoji.length;
        textarea.selectionEnd = startPos + emoji.length;
        textarea.focus();
      });
    },
    canRecall: function canRecall(msg) {
      if (!msg.createdTime) return false;
      // 把 "2024/2/23 12:34:56" 这种字符串格式，或者 ISO 格式转为时间戳
      var timeStr = msg.createdTime;
      if (typeof timeStr === 'string') {
        timeStr = timeStr.replace(/-/g, '/'); // 兼容 iOS 的日期解析
      }
      var msgTime = new Date(timeStr).getTime();
      var now = Date.now();
      // 允许撤回的时间窗口：2分钟 (120,000 毫秒)
      return now - msgTime <= 120000;
    },
    recallMsg: function recallMsg(msg) {
      var _this27 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee19() {
        var _t9;
        return _regenerator().w(function (_context19) {
          while (1) switch (_context19.p = _context19.n) {
            case 0:
              _context19.p = 0;
              _context19.n = 1;
              return _this27.$confirm('确定撤回这条消息吗？', '提示', {
                type: 'warning'
              });
            case 1:
              _context19.n = 2;
              return _this27.$store.dispatch('chat/doRecallMessage', {
                chatId: _this27.currentChatId,
                messageId: msg.id
              });
            case 2:
              _context19.n = 4;
              break;
            case 3:
              _context19.p = 3;
              _t9 = _context19.v;
              if (_t9 !== 'cancel') {
                _this27.$message.error('撤回失败: ' + (_t9.message || '未知错误'));
              }
            case 4:
              return _context19.a(2);
          }
        }, _callee19, null, [[0, 3]]);
      }))();
    },
    isSystemMessage: function isSystemMessage(msg) {
      if (!msg) return false;
      if (this.isStructuredCardMessage(msg)) return false;
      if (msg.senderType === 0 || msg.messageType === 101) return true;
      var content = (msg.content || '').trim();
      if (!content) return false;
      return [/创建了群聊/, /加入了群聊/, /退出了群聊/, /被移出了群聊/, /群主转让/, /将群主转让给了/, /修改群名称为/, /更新了群头像/, /更新了群公告/, /设为管理员/, /取消管理员/, /被设为群主/, /被禁言/, /被解除禁言/, /已开启全员禁言/, /已关闭全员禁言/].some(function (pattern) {
        return pattern.test(content);
      });
    },
    formatSystemMessage: function formatSystemMessage(msg) {
      var content = ((msg === null || msg === void 0 ? void 0 : msg.content) || '').trim();
      return content || '系统消息';
    },
    clearScrollBottomTimers: function clearScrollBottomTimers() {
      var timers = this.scrollBottomTimers || [];
      timers.forEach(function (timer) {
        return clearTimeout(timer);
      });
      this.scrollBottomTimers = [];
    },
    setMessagesScrollToBottom: function setMessagesScrollToBottom() {
      var container = this.$refs.messagesContainer;
      if (!container) return;
      container.scrollTop = container.scrollHeight;
      this.nearBottom = true;
      this.newMessageHintCount = 0;
    },
    scrollToBottom: function scrollToBottom() {
      var _this28 = this;
      this.clearScrollBottomTimers();
      this.$nextTick(function () {
        _this28.setMessagesScrollToBottom();
        var requestFrame = window.requestAnimationFrame || function (callback) {
          return setTimeout(callback, 16);
        };
        requestFrame(function () {
          return _this28.setMessagesScrollToBottom();
        });

        // 多重保障：气泡换行、图片占位和字体渲染可能会在下一帧后继续撑高容器。
        var retryDelays = [80, 180, 360];
        retryDelays.forEach(function (delay) {
          var timer = setTimeout(function () {
            return _this28.setMessagesScrollToBottom();
          }, delay);
          _this28.scrollBottomTimers.push(timer);
        });
      });
    },
    isNearMessagesBottom: function isNearMessagesBottom() {
      var container = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.$refs.messagesContainer;
      if (!container) return true;
      return container.scrollHeight - container.scrollTop - container.clientHeight <= 80;
    },
    handleNewMessageHintClick: function handleNewMessageHintClick() {
      this.newMessageHintCount = 0;
      this.scrollToBottom();
    },
    handleScroll: function handleScroll(e) {
      var _this29 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee20() {
        var container, chatId, hs, scrollHeightBefore, scrollTopBefore;
        return _regenerator().w(function (_context20) {
          while (1) switch (_context20.n) {
            case 0:
              container = e.target;
              _this29.nearBottom = _this29.isNearMessagesBottom(container);
              if (_this29.nearBottom && _this29.newMessageHintCount > 0) {
                _this29.newMessageHintCount = 0;
              }
              // 滚动到顶部时触发加载历史消息
              if (!(container.scrollTop <= 10 && !_this29.loadingHistory)) {
                _context20.n = 4;
                break;
              }
              chatId = _this29.currentChatId;
              if (chatId) {
                _context20.n = 1;
                break;
              }
              return _context20.a(2);
            case 1:
              hs = _this29.$store.state.chat.historyStates[chatId];
              if (!(hs && !hs.hasMore)) {
                _context20.n = 2;
                break;
              }
              return _context20.a(2);
            case 2:
              // 已经没有更多历史记录了

              _this29.loadingHistory = true;

              // 记录滚动条到底部的距离，而不是顶部
              scrollHeightBefore = container.scrollHeight;
              scrollTopBefore = container.scrollTop; // 必须提前捕获，不能在 $nextTick 里读取可能已被改变的值
              _context20.n = 3;
              return _this29.$store.dispatch('chat/loadHistory', chatId);
            case 3:
              _this29.$nextTick(function () {
                // 加载后恢复滚动条位置（保持到底部的相对位置不变）
                var container = _this29.$refs.messagesContainer;
                if (container) {
                  var scrollHeightAfter = container.scrollHeight;
                  container.scrollTop = scrollHeightAfter - scrollHeightBefore + scrollTopBefore;
                  _this29.loadingHistory = false;
                }
              });
            case 4:
              return _context20.a(2);
          }
        }, _callee20);
      }))();
    },
    // 新建对话
    debounceSearch: function debounceSearch() {
      var _this30 = this;
      clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout(function () {
        return _this30.doSearch();
      }, 300);
    },
    doSearch: function doSearch() {
      var _this31 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee21() {
        var keyword, _res$data, _res$data2, res, list, _t0;
        return _regenerator().w(function (_context21) {
          while (1) switch (_context21.p = _context21.n) {
            case 0:
              if (_this31.searchKeyword.trim()) {
                _context21.n = 2;
                break;
              }
              _this31.searchResults = [];
              _context21.n = 1;
              return _this31.ensureContactTypeDataLoaded();
            case 1:
              return _context21.a(2);
            case 2:
              if (!(_this31.selectedContactType === 'parent' || _this31.selectedContactType === 'supplier')) {
                _context21.n = 3;
                break;
              }
              _this31.searchResults = [];
              return _context21.a(2);
            case 3:
              _this31.searchLoading = true;
              _context21.p = 4;
              _context21.n = 5;
              return _this31.ensureContactTypeDataLoaded();
            case 5:
              keyword = _this31.searchKeyword.trim().toLowerCase();
              if (!(_this31.selectedContactType === 'student')) {
                _context21.n = 7;
                break;
              }
              _context21.n = 6;
              return getContactStudents({
                page: 1,
                size: 500,
                status: 1,
                schoolId: _this31.selectedOrgSchoolId || undefined
              });
            case 6:
              res = _context21.v;
              list = (res === null || res === void 0 || (_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.list) || (res === null || res === void 0 || (_res$data2 = res.data) === null || _res$data2 === void 0 ? void 0 : _res$data2.items) || (res === null || res === void 0 ? void 0 : res.data) || [];
              _this31.searchResults = (Array.isArray(list) ? list : []).filter(function (user) {
                var name = String((user === null || user === void 0 ? void 0 : user.name) || '').toLowerCase();
                var phone = String((user === null || user === void 0 ? void 0 : user.phone) || '').toLowerCase();
                return name.includes(keyword) || phone.includes(keyword);
              }).map(function (user) {
                return _this31.normalizeStudentContact(user);
              }).slice(0, 50);
              _context21.n = 8;
              break;
            case 7:
              _this31.searchResults = _this31.orgUsers.filter(function (user) {
                if (!_this31.matchesContactType(user)) return false;
                var name = String((user === null || user === void 0 ? void 0 : user.name) || '').toLowerCase();
                var phone = String((user === null || user === void 0 ? void 0 : user.phone) || '').toLowerCase();
                return name.includes(keyword) || phone.includes(keyword);
              }).slice(0, 50);
            case 8:
              _context21.n = 10;
              break;
            case 9:
              _context21.p = 9;
              _t0 = _context21.v;
              _this31.searchResults = [];
            case 10:
              _this31.searchLoading = false;
            case 11:
              return _context21.a(2);
          }
        }, _callee21, null, [[4, 9]]);
      }))();
    },
    ensureContactTypeDataLoaded: function ensureContactTypeDataLoaded() {
      var _arguments2 = arguments,
        _this32 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee22() {
        var force;
        return _regenerator().w(function (_context22) {
          while (1) switch (_context22.n) {
            case 0:
              force = _arguments2.length > 0 && _arguments2[0] !== undefined ? _arguments2[0] : false;
              if (!(_this32.selectedContactType === 'student')) {
                _context22.n = 2;
                break;
              }
              _context22.n = 1;
              return _this32.ensureStudentContactsLoaded(force);
            case 1:
              return _context22.a(2);
            case 2:
              _context22.n = 3;
              return _this32.ensureOrgContactsLoaded(force);
            case 3:
              return _context22.a(2);
          }
        }, _callee22);
      }))();
    },
    ensureOrgContactsLoaded: function ensureOrgContactsLoaded() {
      var _arguments3 = arguments,
        _this33 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee23() {
        var force, defaultSchool;
        return _regenerator().w(function (_context23) {
          while (1) switch (_context23.n) {
            case 0:
              force = _arguments3.length > 0 && _arguments3[0] !== undefined ? _arguments3[0] : false;
              if (force || !_this33.selectedOrgSchoolId) {
                defaultSchool = _this33.schoolsInSelectedCity[0] || _this33.availableOrgSchools[0] || null;
                _this33.selectedOrgSchoolId = _this33.currentSchoolId || (defaultSchool === null || defaultSchool === void 0 ? void 0 : defaultSchool.id) || null;
              }
              _context23.n = 1;
              return Promise.all([_this33.loadOrgDepartments(force), _this33.loadOrgUsers(force)]);
            case 1:
              return _context23.a(2);
          }
        }, _callee23);
      }))();
    },
    ensureStudentContactsLoaded: function ensureStudentContactsLoaded() {
      var _arguments4 = arguments,
        _this34 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee24() {
        var force, defaultSchool;
        return _regenerator().w(function (_context24) {
          while (1) switch (_context24.n) {
            case 0:
              force = _arguments4.length > 0 && _arguments4[0] !== undefined ? _arguments4[0] : false;
              if (force || !_this34.selectedOrgSchoolId) {
                defaultSchool = _this34.schoolsInSelectedCity[0] || _this34.availableOrgSchools[0] || null;
                _this34.selectedOrgSchoolId = _this34.currentSchoolId || (defaultSchool === null || defaultSchool === void 0 ? void 0 : defaultSchool.id) || null;
              }
              _context24.n = 1;
              return _this34.loadStudentFaculties(force);
            case 1:
              if (force) {
                _this34.selectedStudentFacultyId = null;
                _this34.selectedStudentProfId = null;
                _this34.selectedStudentClazzId = null;
              }
              if (!_this34.selectedStudentFacultyId && _this34.studentFaculties.length > 0) {
                _this34.selectedStudentFacultyId = _this34.studentFaculties[0].id;
              }
              if (!_this34.selectedStudentFacultyId) {
                _context24.n = 3;
                break;
              }
              _context24.n = 2;
              return _this34.loadStudentProfessions(_this34.selectedStudentFacultyId, force);
            case 2:
              _context24.n = 4;
              break;
            case 3:
              _this34.studentProfessions = [];
            case 4:
              if (!_this34.selectedStudentProfId) {
                _context24.n = 6;
                break;
              }
              _context24.n = 5;
              return _this34.loadStudentClazzes(_this34.selectedStudentProfId, force);
            case 5:
              _context24.n = 7;
              break;
            case 6:
              _this34.studentClazzes = [];
            case 7:
              _context24.n = 8;
              return _this34.loadStudentUsers();
            case 8:
              return _context24.a(2);
          }
        }, _callee24);
      }))();
    },
    loadOrgSchools: function loadOrgSchools() {
      var _arguments5 = arguments,
        _this35 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee25() {
        var force, _res$data3, _res$data4, res, list, _t1, _t10;
        return _regenerator().w(function (_context25) {
          while (1) switch (_context25.p = _context25.n) {
            case 0:
              force = _arguments5.length > 0 && _arguments5[0] !== undefined ? _arguments5[0] : false;
              if (!(!force && _this35.orgSchools.length > 0)) {
                _context25.n = 1;
                break;
              }
              return _context25.a(2);
            case 1:
              _this35.orgSchoolsLoading = true;
              _context25.p = 2;
              _context25.n = 3;
              return getContactSchools({
                page: 1,
                size: 1000
              });
            case 3:
              res = _context25.v;
              list = (res === null || res === void 0 || (_res$data3 = res.data) === null || _res$data3 === void 0 ? void 0 : _res$data3.list) || (res === null || res === void 0 || (_res$data4 = res.data) === null || _res$data4 === void 0 ? void 0 : _res$data4.items) || (res === null || res === void 0 ? void 0 : res.data) || [];
              _this35.orgSchools = Array.isArray(list) ? list : [];
              if (!(!_this35.orgSchools.length && _this35.userId)) {
                _context25.n = 4;
                break;
              }
              _context25.n = 4;
              return _this35.$store.dispatch('user/loadUserSchools');
            case 4:
              _context25.n = 9;
              break;
            case 5:
              _context25.p = 5;
              _t1 = _context25.v;
              _this35.orgSchools = [];
              if (!_this35.userId) {
                _context25.n = 9;
                break;
              }
              _context25.p = 6;
              _context25.n = 7;
              return _this35.$store.dispatch('user/loadUserSchools');
            case 7:
              _context25.n = 9;
              break;
            case 8:
              _context25.p = 8;
              _t10 = _context25.v;
            case 9:
              _context25.p = 9;
              _this35.orgSchoolsLoading = false;
              return _context25.f(9);
            case 10:
              return _context25.a(2);
          }
        }, _callee25, null, [[6, 8], [2, 5, 9, 10]]);
      }))();
    },
    loadStudentFaculties: function loadStudentFaculties() {
      var _arguments6 = arguments,
        _this36 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee26() {
        var force, _res$data5, _res$data6, res, list, _t11;
        return _regenerator().w(function (_context26) {
          while (1) switch (_context26.p = _context26.n) {
            case 0:
              force = _arguments6.length > 0 && _arguments6[0] !== undefined ? _arguments6[0] : false;
              if (!(!force && _this36.studentFaculties.length > 0)) {
                _context26.n = 1;
                break;
              }
              return _context26.a(2);
            case 1:
              _this36.studentFacultiesLoading = true;
              _context26.p = 2;
              _context26.n = 3;
              return getContactFaculties({
                page: 1,
                size: 500,
                isAvailable: 1,
                schoolId: _this36.selectedOrgSchoolId || undefined
              });
            case 3:
              res = _context26.v;
              list = (res === null || res === void 0 || (_res$data5 = res.data) === null || _res$data5 === void 0 ? void 0 : _res$data5.list) || (res === null || res === void 0 || (_res$data6 = res.data) === null || _res$data6 === void 0 ? void 0 : _res$data6.items) || (res === null || res === void 0 ? void 0 : res.data) || [];
              _this36.studentFaculties = Array.isArray(list) ? list : [];
              _context26.n = 5;
              break;
            case 4:
              _context26.p = 4;
              _t11 = _context26.v;
              _this36.studentFaculties = [];
            case 5:
              _context26.p = 5;
              _this36.studentFacultiesLoading = false;
              return _context26.f(5);
            case 6:
              return _context26.a(2);
          }
        }, _callee26, null, [[2, 4, 5, 6]]);
      }))();
    },
    loadStudentProfessions: function loadStudentProfessions(facultyId) {
      var _arguments7 = arguments,
        _this37 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee27() {
        var force, cacheKey, _res$data7, _res$data8, res, list, _t12;
        return _regenerator().w(function (_context27) {
          while (1) switch (_context27.p = _context27.n) {
            case 0:
              force = _arguments7.length > 1 && _arguments7[1] !== undefined ? _arguments7[1] : false;
              if (facultyId) {
                _context27.n = 1;
                break;
              }
              _this37.studentProfessions = [];
              return _context27.a(2);
            case 1:
              cacheKey = "".concat(_this37.selectedOrgSchoolId || 'all', "_").concat(facultyId);
              if (!(!force && _this37.studentProfessionsCache[cacheKey])) {
                _context27.n = 2;
                break;
              }
              _this37.studentProfessions = _this37.studentProfessionsCache[cacheKey];
              return _context27.a(2);
            case 2:
              _this37.studentProfessionsLoading = true;
              _context27.p = 3;
              _context27.n = 4;
              return getContactProfessions({
                page: 1,
                size: 500,
                facultyId: facultyId
              });
            case 4:
              res = _context27.v;
              list = (res === null || res === void 0 || (_res$data7 = res.data) === null || _res$data7 === void 0 ? void 0 : _res$data7.list) || (res === null || res === void 0 || (_res$data8 = res.data) === null || _res$data8 === void 0 ? void 0 : _res$data8.items) || (res === null || res === void 0 ? void 0 : res.data) || [];
              _this37.studentProfessions = Array.isArray(list) ? list : [];
              _this37.studentProfessionsCache = _objectSpread(_objectSpread({}, _this37.studentProfessionsCache), {}, _defineProperty({}, cacheKey, _this37.studentProfessions));
              _context27.n = 6;
              break;
            case 5:
              _context27.p = 5;
              _t12 = _context27.v;
              _this37.studentProfessions = [];
            case 6:
              _context27.p = 6;
              _this37.studentProfessionsLoading = false;
              return _context27.f(6);
            case 7:
              return _context27.a(2);
          }
        }, _callee27, null, [[3, 5, 6, 7]]);
      }))();
    },
    loadStudentClazzes: function loadStudentClazzes(profId) {
      var _arguments8 = arguments,
        _this38 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee28() {
        var force, cacheKey, _res$data9, _res$data0, res, list, _t13;
        return _regenerator().w(function (_context28) {
          while (1) switch (_context28.p = _context28.n) {
            case 0:
              force = _arguments8.length > 1 && _arguments8[1] !== undefined ? _arguments8[1] : false;
              if (profId) {
                _context28.n = 1;
                break;
              }
              _this38.studentClazzes = [];
              return _context28.a(2);
            case 1:
              cacheKey = "".concat(_this38.selectedOrgSchoolId || 'all', "_").concat(profId);
              if (!(!force && _this38.studentClazzesCache[cacheKey])) {
                _context28.n = 2;
                break;
              }
              _this38.studentClazzes = _this38.studentClazzesCache[cacheKey];
              return _context28.a(2);
            case 2:
              _this38.studentClazzesLoading = true;
              _context28.p = 3;
              _context28.n = 4;
              return getContactClazzes({
                page: 1,
                size: 1000,
                profId: profId
              });
            case 4:
              res = _context28.v;
              list = (res === null || res === void 0 || (_res$data9 = res.data) === null || _res$data9 === void 0 ? void 0 : _res$data9.list) || (res === null || res === void 0 || (_res$data0 = res.data) === null || _res$data0 === void 0 ? void 0 : _res$data0.items) || (res === null || res === void 0 ? void 0 : res.data) || [];
              _this38.studentClazzes = Array.isArray(list) ? list : [];
              _this38.studentClazzesCache = _objectSpread(_objectSpread({}, _this38.studentClazzesCache), {}, _defineProperty({}, cacheKey, _this38.studentClazzes));
              _context28.n = 6;
              break;
            case 5:
              _context28.p = 5;
              _t13 = _context28.v;
              _this38.studentClazzes = [];
            case 6:
              _context28.p = 6;
              _this38.studentClazzesLoading = false;
              return _context28.f(6);
            case 7:
              return _context28.a(2);
          }
        }, _callee28, null, [[3, 5, 6, 7]]);
      }))();
    },
    loadStudentUsers: function loadStudentUsers() {
      var _this39 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee29() {
        var cacheKey, _res$data1, _res$data10, res, list, _t14;
        return _regenerator().w(function (_context29) {
          while (1) switch (_context29.p = _context29.n) {
            case 0:
              cacheKey = [_this39.selectedOrgSchoolId || 'all', _this39.selectedStudentFacultyId || 'all', _this39.selectedStudentProfId || 'all', _this39.selectedStudentClazzId || 'all'].join('_');
              if (!_this39.studentUsersCache[cacheKey]) {
                _context29.n = 1;
                break;
              }
              _this39.studentUsers = _this39.studentUsersCache[cacheKey];
              return _context29.a(2);
            case 1:
              _this39.studentUsersLoading = true;
              _context29.p = 2;
              _context29.n = 3;
              return getContactStudents({
                page: 1,
                size: 500,
                status: 1,
                schoolId: _this39.selectedOrgSchoolId || undefined,
                facultyId: _this39.selectedStudentFacultyId || undefined,
                profId: _this39.selectedStudentProfId || undefined,
                clazzId: _this39.selectedStudentClazzId || undefined
              });
            case 3:
              res = _context29.v;
              list = (res === null || res === void 0 || (_res$data1 = res.data) === null || _res$data1 === void 0 ? void 0 : _res$data1.list) || (res === null || res === void 0 || (_res$data10 = res.data) === null || _res$data10 === void 0 ? void 0 : _res$data10.items) || (res === null || res === void 0 ? void 0 : res.data) || [];
              _this39.studentUsers = Array.isArray(list) ? list : [];
              _this39.studentUsersCache = _objectSpread(_objectSpread({}, _this39.studentUsersCache), {}, _defineProperty({}, cacheKey, _this39.studentUsers));
              _context29.n = 5;
              break;
            case 4:
              _context29.p = 4;
              _t14 = _context29.v;
              _this39.studentUsers = [];
            case 5:
              _context29.p = 5;
              _this39.studentUsersLoading = false;
              return _context29.f(5);
            case 6:
              return _context29.a(2);
          }
        }, _callee29, null, [[2, 4, 5, 6]]);
      }))();
    },
    loadOrgDepartments: function loadOrgDepartments() {
      var _arguments9 = arguments,
        _this40 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee30() {
        var force, _res$data11, res, list, _t15;
        return _regenerator().w(function (_context30) {
          while (1) switch (_context30.p = _context30.n) {
            case 0:
              force = _arguments9.length > 0 && _arguments9[0] !== undefined ? _arguments9[0] : false;
              if (!(!force && _this40.orgDepts.length > 0)) {
                _context30.n = 1;
                break;
              }
              return _context30.a(2);
            case 1:
              _this40.orgDeptsLoading = true;
              _context30.p = 2;
              _context30.n = 3;
              return getContactDepartments({
                size: 1000
              });
            case 3:
              res = _context30.v;
              list = (res === null || res === void 0 || (_res$data11 = res.data) === null || _res$data11 === void 0 ? void 0 : _res$data11.list) || (res === null || res === void 0 ? void 0 : res.data) || [];
              _this40.orgDepts = Array.isArray(list) ? list : [];
              _context30.n = 5;
              break;
            case 4:
              _context30.p = 4;
              _t15 = _context30.v;
              _this40.orgDepts = [];
            case 5:
              _context30.p = 5;
              _this40.orgDeptsLoading = false;
              return _context30.f(5);
            case 6:
              return _context30.a(2);
          }
        }, _callee30, null, [[2, 4, 5, 6]]);
      }))();
    },
    loadOrgUsers: function loadOrgUsers() {
      var _arguments0 = arguments,
        _this41 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee31() {
        var force, _res$data12, _res$data13, res, list, _t16;
        return _regenerator().w(function (_context31) {
          while (1) switch (_context31.p = _context31.n) {
            case 0:
              force = _arguments0.length > 0 && _arguments0[0] !== undefined ? _arguments0[0] : false;
              if (!(!force && _this41.orgUsers.length > 0)) {
                _context31.n = 1;
                break;
              }
              return _context31.a(2);
            case 1:
              _this41.orgUsersLoading = true;
              _context31.p = 2;
              _context31.n = 3;
              return getContactUsers({
                page: 1,
                size: 500,
                status: 1,
                schoolId: _this41.selectedOrgSchoolId || undefined
              });
            case 3:
              res = _context31.v;
              list = (res === null || res === void 0 || (_res$data12 = res.data) === null || _res$data12 === void 0 ? void 0 : _res$data12.list) || (res === null || res === void 0 || (_res$data13 = res.data) === null || _res$data13 === void 0 ? void 0 : _res$data13.items) || (res === null || res === void 0 ? void 0 : res.data) || [];
              _this41.orgUsers = Array.isArray(list) ? list : [];
              _context31.n = 5;
              break;
            case 4:
              _context31.p = 4;
              _t16 = _context31.v;
              _this41.orgUsers = [];
            case 5:
              _context31.p = 5;
              _this41.orgUsersLoading = false;
              return _context31.f(5);
            case 6:
              return _context31.a(2);
          }
        }, _callee31, null, [[2, 4, 5, 6]]);
      }))();
    },
    selectOrgSchool: function selectOrgSchool(schoolId) {
      var _this42 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee32() {
        return _regenerator().w(function (_context32) {
          while (1) switch (_context32.n) {
            case 0:
              _this42.selectedOrgSchoolId = schoolId;
              _this42.selectedOrgDeptId = null;
              _this42.searchResults = [];
              _this42.resetStudentHierarchy();
              if (!_this42.searchKeyword) {
                _context32.n = 2;
                break;
              }
              _context32.n = 1;
              return _this42.doSearch();
            case 1:
              return _context32.a(2);
            case 2:
              if (!(_this42.selectedContactType === 'student')) {
                _context32.n = 4;
                break;
              }
              _context32.n = 3;
              return _this42.ensureStudentContactsLoaded(true);
            case 3:
              return _context32.a(2);
            case 4:
              _context32.n = 5;
              return _this42.loadOrgUsers(true);
            case 5:
              return _context32.a(2);
          }
        }, _callee32);
      }))();
    },
    selectOrgCity: function selectOrgCity(cityKey) {
      this.selectedOrgCityKey = cityKey;
      this.selectedOrgDeptId = null;
      this.resetStudentHierarchy();
      var nextSchool = this.schoolsInSelectedCity[0];
      this.selectedOrgSchoolId = (nextSchool === null || nextSchool === void 0 ? void 0 : nextSchool.id) || null;
      if (this.searchKeyword) {
        this.doSearch();
        return;
      }
      if (this.selectedContactType === 'student') {
        this.ensureStudentContactsLoaded(true);
        return;
      }
      this.loadOrgUsers(true);
    },
    selectOrgDept: function selectOrgDept(deptId) {
      this.selectedOrgDeptId = deptId;
    },
    selectContactType: function selectContactType(item) {
      var _this43 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee33() {
        return _regenerator().w(function (_context33) {
          while (1) switch (_context33.n) {
            case 0:
              if (!(!item || item.disabled)) {
                _context33.n = 1;
                break;
              }
              _this43.$message.info('该联系人入口后续补充');
              return _context33.a(2);
            case 1:
              _this43.selectedContactType = item.value;
              _this43.searchResults = [];
              if (!(item.value === 'student')) {
                _context33.n = 4;
                break;
              }
              _this43.selectedOrgDeptId = null;
              _this43.resetStudentHierarchy();
              _context33.n = 2;
              return _this43.ensureStudentContactsLoaded(true);
            case 2:
              if (!_this43.searchKeyword) {
                _context33.n = 3;
                break;
              }
              _context33.n = 3;
              return _this43.doSearch();
            case 3:
              return _context33.a(2);
            case 4:
              if (!_this43.searchKeyword) {
                _context33.n = 6;
                break;
              }
              _context33.n = 5;
              return _this43.doSearch();
            case 5:
              return _context33.a(2);
            case 6:
              _context33.n = 7;
              return _this43.ensureOrgContactsLoaded(true);
            case 7:
              return _context33.a(2);
          }
        }, _callee33);
      }))();
    },
    resetStudentHierarchy: function resetStudentHierarchy() {
      this.selectedStudentFacultyId = null;
      this.selectedStudentProfId = null;
      this.selectedStudentClazzId = null;
      this.studentProfessions = [];
      this.studentClazzes = [];
      this.studentUsers = [];
      this.studentProfessionsCache = {};
      this.studentClazzesCache = {};
      this.studentUsersCache = {};
    },
    getStudentPanelItemKey: function getStudentPanelItemKey(item) {
      if (!item) return '';
      if (item.type === 'faculty-all') return 'faculty:all';
      if (item.type === 'profession-all') return 'profession:all';
      if (item.type === 'clazz-all') return 'clazz:all';
      return "".concat(item.type, ":").concat(item.id);
    },
    selectStudentPanelItem: function selectStudentPanelItem(item) {
      var _this44 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee34() {
        return _regenerator().w(function (_context34) {
          while (1) switch (_context34.n) {
            case 0:
              if (item) {
                _context34.n = 1;
                break;
              }
              return _context34.a(2);
            case 1:
              if (!(item.type === 'faculty-all')) {
                _context34.n = 3;
                break;
              }
              _this44.selectedStudentFacultyId = null;
              _this44.selectedStudentProfId = null;
              _this44.selectedStudentClazzId = null;
              _this44.studentProfessions = [];
              _this44.studentClazzes = [];
              _context34.n = 2;
              return _this44.loadStudentUsers();
            case 2:
              return _context34.a(2);
            case 3:
              if (!(item.type === 'faculty')) {
                _context34.n = 6;
                break;
              }
              _this44.selectedStudentFacultyId = item.id;
              _this44.selectedStudentProfId = null;
              _this44.selectedStudentClazzId = null;
              _this44.studentClazzes = [];
              _context34.n = 4;
              return _this44.loadStudentProfessions(item.id, true);
            case 4:
              _context34.n = 5;
              return _this44.loadStudentUsers();
            case 5:
              return _context34.a(2);
            case 6:
              if (!(item.type === 'profession-all')) {
                _context34.n = 8;
                break;
              }
              _this44.selectedStudentProfId = null;
              _this44.selectedStudentClazzId = null;
              _this44.studentClazzes = [];
              _context34.n = 7;
              return _this44.loadStudentUsers();
            case 7:
              return _context34.a(2);
            case 8:
              if (!(item.type === 'profession')) {
                _context34.n = 11;
                break;
              }
              _this44.selectedStudentProfId = item.id;
              _this44.selectedStudentClazzId = null;
              _context34.n = 9;
              return _this44.loadStudentClazzes(item.id, true);
            case 9:
              _context34.n = 10;
              return _this44.loadStudentUsers();
            case 10:
              return _context34.a(2);
            case 11:
              if (!(item.type === 'clazz-all')) {
                _context34.n = 13;
                break;
              }
              _this44.selectedStudentClazzId = null;
              _context34.n = 12;
              return _this44.loadStudentUsers();
            case 12:
              return _context34.a(2);
            case 13:
              if (!(item.type === 'clazz')) {
                _context34.n = 14;
                break;
              }
              _this44.selectedStudentClazzId = item.id;
              _context34.n = 14;
              return _this44.loadStudentUsers();
            case 14:
              return _context34.a(2);
          }
        }, _callee34);
      }))();
    },
    handleStudentBreadcrumbClick: function handleStudentBreadcrumbClick(crumb, index) {
      var _this45 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee35() {
        return _regenerator().w(function (_context35) {
          while (1) switch (_context35.n) {
            case 0:
              if (crumb) {
                _context35.n = 1;
                break;
              }
              return _context35.a(2);
            case 1:
              if (!(index === _this45.studentBreadcrumbs.length - 1)) {
                _context35.n = 2;
                break;
              }
              return _context35.a(2);
            case 2:
              if (!(crumb.level === 'root')) {
                _context35.n = 4;
                break;
              }
              _this45.selectedStudentFacultyId = null;
              _this45.selectedStudentProfId = null;
              _this45.selectedStudentClazzId = null;
              _this45.studentProfessions = [];
              _this45.studentClazzes = [];
              _context35.n = 3;
              return _this45.loadStudentUsers();
            case 3:
              return _context35.a(2);
            case 4:
              if (!(crumb.level === 'faculty')) {
                _context35.n = 6;
                break;
              }
              _this45.selectedStudentProfId = null;
              _this45.selectedStudentClazzId = null;
              _this45.studentClazzes = [];
              _context35.n = 5;
              return _this45.loadStudentUsers();
            case 5:
              return _context35.a(2);
            case 6:
              if (!(crumb.level === 'profession')) {
                _context35.n = 7;
                break;
              }
              _this45.selectedStudentClazzId = null;
              _context35.n = 7;
              return _this45.loadStudentUsers();
            case 7:
              return _context35.a(2);
          }
        }, _callee35);
      }))();
    },
    getStudentAvatar: function getStudentAvatar(user) {
      return (user === null || user === void 0 ? void 0 : user.avatar) || (user === null || user === void 0 ? void 0 : user.faceImg) || '';
    },
    getStudentSchoolName: function getStudentSchoolName(user) {
      var _user$school4, _user$clazz;
      return (user === null || user === void 0 || (_user$school4 = user.school) === null || _user$school4 === void 0 ? void 0 : _user$school4.name) || (user === null || user === void 0 || (_user$clazz = user.clazz) === null || _user$clazz === void 0 || (_user$clazz = _user$clazz[0]) === null || _user$clazz === void 0 || (_user$clazz = _user$clazz.school) === null || _user$clazz === void 0 ? void 0 : _user$clazz.name) || '';
    },
    getStudentOrgPath: function getStudentOrgPath(user) {
      var _user$clazz2, _user$classes, _user$faculty, _clazz$prof, _user$prof, _clazz$prof2;
      var clazz = (user === null || user === void 0 || (_user$clazz2 = user.clazz) === null || _user$clazz2 === void 0 ? void 0 : _user$clazz2[0]) || (user === null || user === void 0 || (_user$classes = user.classes) === null || _user$classes === void 0 ? void 0 : _user$classes[0]) || null;
      var facultyName = (user === null || user === void 0 || (_user$faculty = user.faculty) === null || _user$faculty === void 0 ? void 0 : _user$faculty.name) || (clazz === null || clazz === void 0 || (_clazz$prof = clazz.prof) === null || _clazz$prof === void 0 || (_clazz$prof = _clazz$prof.faculty) === null || _clazz$prof === void 0 ? void 0 : _clazz$prof.name) || '';
      var profName = (user === null || user === void 0 || (_user$prof = user.prof) === null || _user$prof === void 0 ? void 0 : _user$prof.name) || (clazz === null || clazz === void 0 || (_clazz$prof2 = clazz.prof) === null || _clazz$prof2 === void 0 ? void 0 : _clazz$prof2.name) || '';
      var clazzName = (clazz === null || clazz === void 0 ? void 0 : clazz.name) || '';
      return [facultyName, profName, clazzName].filter(Boolean).join(' / ');
    },
    normalizeStudentContact: function normalizeStudentContact(user) {
      return _objectSpread(_objectSpread({}, user), {}, {
        avatar: this.getStudentAvatar(user)
      });
    },
    startChatWith: function startChatWith(user) {
      var _this46 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee36() {
        var existing, chatId, chat;
        return _regenerator().w(function (_context36) {
          while (1) switch (_context36.n) {
            case 0:
              // 检查是否已有会话
              existing = _this46.chats.find(function (c) {
                return c.userId === user.id;
              });
              if (!existing) {
                _context36.n = 1;
                break;
              }
              _this46.openChat(existing);
              return _context36.a(2);
            case 1:
              _context36.n = 2;
              return _this46.$store.dispatch('chat/createNewChat', user);
            case 2:
              chatId = _context36.v;
              if (chatId) {
                chat = _this46.chats.find(function (c) {
                  return c.id === chatId;
                });
                if (chat) _this46.openChat(chat);
              }
            case 3:
              return _context36.a(2);
          }
        }, _callee36);
      }))();
    }
  }
};